import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Container, Row, Col, Card, Button, Form, Badge, Table, Spinner, InputGroup, OverlayTrigger, Popover, Pagination, Dropdown, Modal } from 'react-bootstrap';
import { FaBroadcastTower, FaUsers, FaHistory, FaCheckCircle, FaExclamationTriangle, FaEnvelopeOpenText, FaPlus, FaFileUpload, FaGlobe, FaBuilding, FaTrash, FaRegCommentDots, FaTimes, FaSearch, FaFilter, FaFileExcel, FaFileCsv, FaTag, FaUser, FaPhone, FaLink, FaEdit, FaWhatsapp, FaEnvelope, FaQrcode, FaSync, FaBan, FaSignOutAlt, FaCheck, FaExclamationCircle, FaRocket, FaYoutube, FaInstagram, FaFacebook, FaSave, FaDownload } from 'react-icons/fa';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import axios from 'axios';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { io } from 'socket.io-client';
import './AdminOutreach.css';
import { CAMPAIGN_TEMPLATES } from '../../../Constants/campaignTemplates';
import { countryStateCityData } from '../../../Constants/locationData';

const countryData = [
    { name: 'Afghanistan', code: 'AF', dial_code: '+93' },
    { name: 'Albania', code: 'AL', dial_code: '+355' },
    { name: 'Algeria', code: 'DZ', dial_code: '+213' },
    { name: 'Andorra', code: 'AD', dial_code: '+376' },
    { name: 'Angola', code: 'AO', dial_code: '+244' },
    { name: 'Argentina', code: 'AR', dial_code: '+54' },
    { name: 'Armenia', code: 'AM', dial_code: '+374' },
    { name: 'Australia', code: 'AU', dial_code: '+61' },
    { name: 'Austria', code: 'AT', dial_code: '+43' },
    { name: 'Azerbaijan', code: 'AZ', dial_code: '+994' },
    { name: 'Bahamas', code: 'BS', dial_code: '+1' },
    { name: 'Bahrain', code: 'BH', dial_code: '+973' },
    { name: 'Bangladesh', code: 'BD', dial_code: '+880' },
    { name: 'Barbados', code: 'BB', dial_code: '+1' },
    { name: 'Belarus', code: 'BY', dial_code: '+375' },
    { name: 'Belgium', code: 'BE', dial_code: '+32' },
    { name: 'Belize', code: 'BZ', dial_code: '+501' },
    { name: 'Benin', code: 'BJ', dial_code: '+229' },
    { name: 'Bhutan', code: 'BT', dial_code: '+975' },
    { name: 'Bolivia', code: 'BO', dial_code: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', dial_code: '+387' },
    { name: 'Botswana', code: 'BW', dial_code: '+267' },
    { name: 'Brazil', code: 'BR', dial_code: '+55' },
    { name: 'Brunei', code: 'BN', dial_code: '+673' },
    { name: 'Bulgaria', code: 'BG', dial_code: '+359' },
    { name: 'Burkina Faso', code: 'BF', dial_code: '+226' },
    { name: 'Burundi', code: 'BI', dial_code: '+257' },
    { name: 'Cambodia', code: 'KH', dial_code: '+855' },
    { name: 'Cameroon', code: 'CM', dial_code: '+237' },
    { name: 'Canada', code: 'CA', dial_code: '+1' },
    { name: 'Cape Verde', code: 'CV', dial_code: '+238' },
    { name: 'Central African Republic', code: 'CF', dial_code: '+236' },
    { name: 'Chad', code: 'TD', dial_code: '+235' },
    { name: 'Chile', code: 'CL', dial_code: '+56' },
    { name: 'China', code: 'CN', dial_code: '+86' },
    { name: 'Colombia', code: 'CO', dial_code: '+57' },
    { name: 'Comoros', code: 'KM', dial_code: '+269' },
    { name: 'Congo', code: 'CG', dial_code: '+242' },
    { name: 'Costa Rica', code: 'CR', dial_code: '+506' },
    { name: 'Croatia', code: 'HR', dial_code: '+385' },
    { name: 'Cuba', code: 'CU', dial_code: '+53' },
    { name: 'Cyprus', code: 'CY', dial_code: '+357' },
    { name: 'Czech Republic', code: 'CZ', dial_code: '+420' },
    { name: 'Denmark', code: 'DK', dial_code: '+45' },
    { name: 'Djibouti', code: 'DJ', dial_code: '+253' },
    { name: 'Dominica', code: 'DM', dial_code: '+1' },
    { name: 'Dominican Republic', code: 'DO', dial_code: '+1' },
    { name: 'Ecuador', code: 'EC', dial_code: '+593' },
    { name: 'Egypt', code: 'EG', dial_code: '+20' },
    { name: 'El Salvador', code: 'SV', dial_code: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', dial_code: '+240' },
    { name: 'Eritrea', code: 'ER', dial_code: '+291' },
    { name: 'Estonia', code: 'EE', dial_code: '+372' },
    { name: 'Ethiopia', code: 'ET', dial_code: '+251' },
    { name: 'Fiji', code: 'FJ', dial_code: '+679' },
    { name: 'Finland', code: 'FI', dial_code: '+358' },
    { name: 'France', code: 'FR', dial_code: '+33' },
    { name: 'Gabon', code: 'GA', dial_code: '+241' },
    { name: 'Gambia', code: 'GM', dial_code: '+220' },
    { name: 'Georgia', code: 'GE', dial_code: '+995' },
    { name: 'Germany', code: 'DE', dial_code: '+49' },
    { name: 'Ghana', code: 'GH', dial_code: '+233' },
    { name: 'Greece', code: 'GR', dial_code: '+30' },
    { name: 'Grenada', code: 'GD', dial_code: '+1' },
    { name: 'Guatemala', code: 'GT', dial_code: '+502' },
    { name: 'Guinea', code: 'GN', dial_code: '+224' },
    { name: 'Guinea-Bissau', code: 'GW', dial_code: '+245' },
    { name: 'Guyana', code: 'GY', dial_code: '+592' },
    { name: 'Haiti', code: 'HT', dial_code: '+509' },
    { name: 'Honduras', code: 'HN', dial_code: '+504' },
    { name: 'Hungary', code: 'HU', dial_code: '+36' },
    { name: 'Iceland', code: 'IS', dial_code: '+354' },
    { name: 'India', code: 'IN', dial_code: '+91' },
    { name: 'Indonesia', code: 'ID', dial_code: '+62' },
    { name: 'Iran', code: 'IR', dial_code: '+98' },
    { name: 'Iraq', code: 'IQ', dial_code: '+964' },
    { name: 'Ireland', code: 'IE', dial_code: '+353' },
    { name: 'Israel', code: 'IL', dial_code: '+972' },
    { name: 'Italy', code: 'IT', dial_code: '+39' },
    { name: 'Jamaica', code: 'JM', dial_code: '+1' },
    { name: 'Japan', code: 'JP', dial_code: '+81' },
    { name: 'Jordan', code: 'JO', dial_code: '+962' },
    { name: 'Kazakhstan', code: 'KZ', dial_code: '+7' },
    { name: 'Kenya', code: 'KE', dial_code: '+254' },
    { name: 'Korea (South)', code: 'KR', dial_code: '+82' },
    { name: 'Kuwait', code: 'KW', dial_code: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', dial_code: '+996' },
    { name: 'Latvia', code: 'LV', dial_code: '+371' },
    { name: 'Lebanon', code: 'LB', dial_code: '+961' },
    { name: 'Libya', code: 'LY', dial_code: '+218' },
    { name: 'Lithuania', code: 'LT', dial_code: '+370' },
    { name: 'Luxembourg', code: 'LU', dial_code: '+352' },
    { name: 'Malaysia', code: 'MY', dial_code: '+60' },
    { name: 'Malta', code: 'MT', dial_code: '+356' },
    { name: 'Mexico', code: 'MX', dial_code: '+52' },
    { name: 'Morocco', code: 'MA', dial_code: '+212' },
    { name: 'Nepal', code: 'NP', dial_code: '+977' },
    { name: 'Netherlands', code: 'NL', dial_code: '+31' },
    { name: 'New Zealand', code: 'NZ', dial_code: '+64' },
    { name: 'Nigeria', code: 'NG', dial_code: '+234' },
    { name: 'Norway', code: 'NO', dial_code: '+47' },
    { name: 'Oman', code: 'OM', dial_code: '+968' },
    { name: 'Pakistan', code: 'PK', dial_code: '+92' },
    { name: 'Palestine', code: 'PS', dial_code: '+970' },
    { name: 'Peru', code: 'PE', dial_code: '+51' },
    { name: 'Philippines', code: 'PH', dial_code: '+63' },
    { name: 'Poland', code: 'PL', dial_code: '+48' },
    { name: 'Portugal', code: 'PT', dial_code: '+351' },
    { name: 'Qatar', code: 'QA', dial_code: '+974' },
    { name: 'Romania', code: 'RO', dial_code: '+40' },
    { name: 'Russia', code: 'RU', dial_code: '+7' },
    { name: 'Saudi Arabia', code: 'SA', dial_code: '+966' },
    { name: 'Singapore', code: 'SG', dial_code: '+65' },
    { name: 'South Africa', code: 'ZA', dial_code: '+27' },
    { name: 'Spain', code: 'ES', dial_code: '+34' },
    { name: 'Sri Lanka', code: 'LK', dial_code: '+94' },
    { name: 'Sudan', code: 'SD', dial_code: '+249' },
    { name: 'Sweden', code: 'SE', dial_code: '+46' },
    { name: 'Switzerland', code: 'CH', dial_code: '+41' },
    { name: 'Syria', code: 'SY', dial_code: '+963' },
    { name: 'Thailand', code: 'TH', dial_code: '+66' },
    { name: 'Tunisia', code: 'TN', dial_code: '+216' },
    { name: 'Turkey', code: 'TR', dial_code: '+90' },
    { name: 'Uganda', code: 'UG', dial_code: '+256' },
    { name: 'Ukraine', code: 'UA', dial_code: '+380' },
    { name: 'United Arab Emirates', code: 'AE', dial_code: '+971' },
    { name: 'United Kingdom', code: 'GB', dial_code: '+44' },
    { name: 'United States', code: 'US', dial_code: '+1' },
    { name: 'Vietnam', code: 'VN', dial_code: '+84' },
    { name: 'Yemen', code: 'YE', dial_code: '+967' },
    { name: 'Zimbabwe', code: 'ZW', dial_code: '+263' }
];

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PASTE_NATIONALITY_COUNTRY_MAP = {
    filipino: 'Philippines',
    filipina: 'Philippines',
    indian: 'India',
    indonesian: 'Indonesia'
};

const normalizePastedLabel = (value = '') =>
    value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

const extractCountryDialCode = (countryName) =>
    countryData.find(c => c.name.toLowerCase() === String(countryName || '').toLowerCase())?.dial_code || '+974';

const normalizePastedNationality = (value = '') => {
    const trimmed = value.trim();
    if (!trimmed) return '';
    const mapped = PASTE_NATIONALITY_COUNTRY_MAP[trimmed.toLowerCase()];
    if (mapped) return mapped;
    const countryMatch = countryData.find(c => c.name.toLowerCase() === trimmed.toLowerCase());
    return countryMatch?.name || trimmed;
};

const detectCategoryFromJobPosition = (jobPosition = '') => {
    const normalized = jobPosition.toLowerCase();
    if (/(driver|lady driver|home driver|cook|maid|nanny|housemaid)/.test(normalized)) return 'Domestic Helper';
    if (/(nurse|caregiver|doctor)/.test(normalized)) return 'Healthcare';
    return '';
};

const parseOutreachPastedText = (rawText = '') => {
    const labelMap = {
        name: 'name',
        fullname: 'name',
        candidatename: 'name',
        jobapplied: 'jobApplied',
        gender: 'gender',
        age: 'age',
        nationality: 'nationality',
        religion: 'religion',
        mobilenumber: 'mobileNumber',
        whatsappnumber: 'whatsappNumber',
        emailid: 'email'
    };
    const values = {};
    const splitPhoneValues = (value = '') =>
        value
            .split(/\s*(?:,|;|\/|\||\bor\b)\s*/i)
            .map(item => item.trim())
            .filter(Boolean);
    const extractEmailValues = (value = '') =>
        value.match(/[^\s,;]+@[^\s,;]+/g)?.map(item => item.trim().toLowerCase()) || [];

    rawText.split(/\r?\n/).forEach((line) => {
        const cleanedLine = line.replace(/^[\s*•⁠-]+/u, '').trim();
        if (!cleanedLine) return;

        const match = cleanedLine.match(/^([^:]+)\s*:\s*(.+)$/);
        if (!match) return;

        const key = labelMap[normalizePastedLabel(match[1])];
        if (!key) return;

        const rawValue = match[2].trim();
        if (key === 'mobileNumber') {
            values.mobileNumbers = [...(values.mobileNumbers || []), ...splitPhoneValues(rawValue)];
            return;
        }
        if (key === 'whatsappNumber') {
            values.whatsappNumbers = [...(values.whatsappNumbers || []), ...splitPhoneValues(rawValue)];
            return;
        }
        if (key === 'email') {
            values.emails = [...(values.emails || []), ...extractEmailValues(rawValue)];
            return;
        }

        values[key] = rawValue;
    });

    return values;
};

const buildPastedMobile = (rawNumber = '', fallbackCountryCode = '+974') => {
    const trimmed = rawNumber.trim();
    if (!trimmed) return null;

    if (trimmed.startsWith('+')) {
        return {
            countryCode: '',
            number: `+${trimmed.replace(/[^\d]/g, '')}`
        };
    }

    return {
        countryCode: fallbackCountryCode,
        number: trimmed.replace(/[^\d]/g, '')
    };
};

const normalizeHeader = (value = '') =>
    value.toString().trim().toLowerCase().replace(/[^a-z0-9]/g, '');

const duplicateReasonLabel = {
    website: 'Website duplicate',
    phone: 'Phone duplicate',
    name_country: 'Name + country duplicate',
    saved: 'Saved in leads'
};

const parseCSVLine = (line = '') => {
    const values = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i += 1) {
        const char = line[i];
        const next = line[i + 1];
        if (char === '"') {
            if (inQuotes && next === '"') { current += '"'; i += 1; }
            else { inQuotes = !inQuotes; }
            continue;
        }
        if (char === ',' && !inQuotes) { values.push(current.trim()); current = ''; continue; }
        current += char;
    }
    values.push(current.trim());
    return values;
};

// Searchable Dropdown
const SearchableDropdown = ({ options, value, onChange, placeholder, icon, className, disabled }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const filteredOptions = options.filter(opt =>
        opt.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        opt.value.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(opt.subtext || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleSelect = (opt) => { onChange(opt.value); setSearchTerm(''); setIsOpen(false); };
    return (
        <div className={`searchable-dropdown ${className || ''}`} style={{ position: 'relative', opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
            <InputGroup onClick={() => !disabled && setIsOpen(!isOpen)} className="h-100">
                {icon && <InputGroup.Text className="bg-light border-end-0">{icon}</InputGroup.Text>}
                <Form.Control
                    type="text"
                    placeholder={placeholder || (disabled ? "Select category first..." : "Select...")}
                    value={isOpen ? searchTerm : (value || '')}
                    readOnly={!isOpen}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={`bg-light ${!disabled ? 'cursor-pointer' : ''} ${icon ? 'border-start-0' : ''}`} disabled={disabled}
                    autoComplete="off"
                    style={{ caretColor: isOpen ? 'auto' : 'transparent', height: '100%' }}
                />
                <InputGroup.Text className="bg-light border-start-0 cursor-pointer">
                    <FaGlobe size={12} className={isOpen ? 'text-primary' : 'text-muted'} />
                </InputGroup.Text>
            </InputGroup>
            {isOpen && (
                <div className="dropdown-menu show shadow-lg w-100 p-0" style={{ maxHeight: '250px', overflowY: 'auto', position: 'absolute', top: '100%', left: 0, zIndex: 1050 }}>
                    {filteredOptions.length > 0 ? filteredOptions.map((opt, idx) => (
                        <button key={idx} className="dropdown-item py-2 px-3 d-flex justify-content-between align-items-center" type="button" onClick={(e) => { e.stopPropagation(); handleSelect(opt); }}>
                            <span className={opt.value === value ? 'fw-bold text-primary' : ''}>{opt.label}</span>
                            {opt.subtext && <span className="small text-muted">{opt.subtext}</span>}
                        </button>
                    )) : (<div className="p-3 text-muted small">No results matching "{searchTerm}"</div>)}
                </div>
            )}
            {isOpen && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1040 }} onClick={(e) => { e.stopPropagation(); setIsOpen(false); }} />}
        </div>
    );
};

// Pagination component helper
const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

    for (let i = start; i <= end; i++) pages.push(i);

    return (
        <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top bg-light">
            <small className="text-muted">Page {currentPage} of {totalPages}</small>
            <Pagination size="sm" className="mb-0">
                <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} />
                {start > 1 && <Pagination.Ellipsis disabled />}
                {pages.map(p => <Pagination.Item key={p} active={p === currentPage} onClick={() => onPageChange(p)}>{p}</Pagination.Item>)}
                {end < totalPages && <Pagination.Ellipsis disabled />}
                <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} />
            </Pagination>
        </div>
    );
};

// ── Advanced Download configuration ──
const EXPORT_FIELD_OPTIONS = [
    { key: 'owner_name',     label: 'Owner / Contact Person' },
    { key: 'agency_name',    label: 'Agency Name' },
    { key: 'emails',         label: 'Email' },
    { key: 'mobiles',        label: 'Mobile' },
    { key: 'country',        label: 'Country' },
    { key: 'province',       label: 'Province / State' },
    { key: 'city',           label: 'City' },
    { key: 'category',       label: 'Category' },
    { key: 'job_position',   label: 'Job Position' },
    { key: 'gender',         label: 'Gender' },
    { key: 'age',            label: 'Age' },
    { key: 'website',        label: 'Website' },
    { key: 'youtube_link',   label: 'YouTube' },
    { key: 'instagram_link', label: 'Instagram' },
    { key: 'facebook_link',  label: 'Facebook' },
    { key: 'created_at',     label: 'Added Date' }
];

const PHONE_FORMAT_OPTIONS = [
    { key: 'plus',               label: 'With Country Code (+974XXXX)',  hint: 'No space between country code and number' },
    { key: 'doubleZero',         label: '00 Format (00974XXXX)',          hint: 'Country code prefixed with 00' },
    { key: 'withoutPlus',        label: 'Country Code Only (974XXXX)',    hint: 'Country code without the + symbol' },
    { key: 'startingZero',       label: 'Starting with 0 (0XXXX)',        hint: 'Country code removed, prepended with 0' },
    { key: 'withoutCountryCode', label: 'Number Only (XXXX)',             hint: 'Strips country code and any leading zeros' }
];

const EXPORT_PREFS_STORAGE_KEY = 'gulfworker_outreach_export_prefs';

// Sorted dial-code digits (longest first) for accurate prefix matching against numbers
// that already include a country code embedded in the string.
let SORTED_DIAL_CODE_DIGITS = null;
const getSortedDialCodes = () => {
    if (SORTED_DIAL_CODE_DIGITS) return SORTED_DIAL_CODE_DIGITS;
    const list = (countryData || [])
        .map(item => String(item.dial_code || '').replace(/\D/g, ''))
        .filter(Boolean);
    SORTED_DIAL_CODE_DIGITS = [...new Set(list)].sort((a, b) => b.length - a.length);
    return SORTED_DIAL_CODE_DIGITS;
};

const normalizeDefaultCode = (dialCode = '') =>
    String(dialCode || '').replace(/\D/g, '');

// Resolve a mobile entry to { codeDigits, localDigits }.
// Bulk-outreach mobiles are stored as {countryCode, number} pairs, so prefer those.
// Fallback rules avoid false positives on raw local digits.
const detectCountryAndLocal = (mobile) => {
    if (!mobile) return { codeDigits: '', localDigits: '' };

    if (typeof mobile !== 'string') {
        const explicitCode = normalizeDefaultCode(mobile.countryCode);
        const numberRaw = String(mobile.number || '').trim();
        if (!numberRaw && !explicitCode) return { codeDigits: '', localDigits: '' };

        if (explicitCode) {
            return { codeDigits: explicitCode, localDigits: numberRaw.replace(/\D/g, '') };
        }
        // No explicit code: only try to extract one if the number string itself is prefixed
        return detectCountryAndLocal(numberRaw);
    }

    const raw = mobile.trim();
    if (!raw) return { codeDigits: '', localDigits: '' };
    const digits = raw.replace(/\D/g, '');
    if (!digits) return { codeDigits: '', localDigits: '' };

    const hasPlus = raw.startsWith('+');
    const hasDoubleZero = !hasPlus && raw.startsWith('00');

    if (!hasPlus && !hasDoubleZero) {
        return { codeDigits: '', localDigits: digits };
    }

    const stripped = hasDoubleZero ? digits.replace(/^0+/, '') : digits;
    const dialCodes = getSortedDialCodes();
    for (const dc of dialCodes) {
        if (stripped.startsWith(dc) && stripped.length - dc.length >= 6) {
            return { codeDigits: dc, localDigits: stripped.slice(dc.length) };
        }
    }
    const codeLen = Math.min(3, Math.max(0, stripped.length - 6));
    return {
        codeDigits: stripped.slice(0, codeLen),
        localDigits: stripped.slice(codeLen)
    };
};

const formatMobileForExport = (mobile, format, defaultCountryCode = '') => {
    const detected = detectCountryAndLocal(mobile);
    let { codeDigits, localDigits } = detected;
    if (!codeDigits && !localDigits) return '';

    if (!codeDigits && defaultCountryCode) {
        codeDigits = normalizeDefaultCode(defaultCountryCode);
    }

    switch (format) {
        case 'plus':
            return codeDigits ? `+${codeDigits}${localDigits}` : `+${localDigits}`;
        case 'doubleZero':
            return codeDigits ? `00${codeDigits}${localDigits}` : localDigits;
        case 'withoutPlus':
            return codeDigits ? `${codeDigits}${localDigits}` : localDigits;
        case 'startingZero': {
            const cleanLocal = localDigits.replace(/^0+/, '');
            return cleanLocal ? `0${cleanLocal}` : '';
        }
        case 'withoutCountryCode':
            return localDigits.replace(/^0+/, '');
        default:
            return codeDigits ? `+${codeDigits}${localDigits}` : localDigits;
    }
};

const loadExportPrefs = () => {
    try {
        const raw = localStorage.getItem(EXPORT_PREFS_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
    } catch (e) {
        return null;
    }
};

const persistExportPrefs = (prefs) => {
    try {
        localStorage.setItem(EXPORT_PREFS_STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) { /* ignore */ }
};

const AdminBulkOutreach = () => {
    // Category options from register page
    const CATEGORY_OPTIONS = [
        'Domestic Helper',
        'Healthcare',
        'Hospitality',
        'Software / IT',
        'Construction',
        'Retail & Sales',
        'Cleaning & Maintenance',
        'Company Worker',
        'Manpower Agency',
        'Employer'
    ];

    const JOB_POSITIONS_BY_CATEGORY = {
        "Domestic Helper": [
                "Domestic Helper",
                "Maid",
                "Housemaid",
                "Houseboy",
                "Housekeeper",
                "Household Administrator",
                "House Manager",
                "Domestic Assistant",
                "Nanny",
                "Baby Sitter",
                "Caregiver",
                "Elder Care",
                "Pet Sitter",
                "Home Caregiver",
                "Personal Assistant",
                "Home Cook",
                "Cook",
                "Cook (Company / House)",
                "Personal Chef",
                "Home Driver",
                "Personal Driver",
                "Lady Driver",
                "Driver",
                "Private Drivers",
                "Motorbike Driver",
                "Chauffeur",
                "Tailor",
                "Teacher",
                "Trainer",
                "Tutor",
                "Beautician",
                "Gardener",
                "Butler",
                "Laundry Worker",
                "Cleaner",
                "Maintenance Worker",
                "Home Nurse",
                "Kitchen Staff",
                "Dining Room Attendant",
                "Event Coordinator",
                "Farmar",
                "Maid + Driver (Couple)",
                "Housemaid + Driver (Couple)",
                "Housekeeper + Driver (Couple)",
                "Cleaner + Driver (Couple)",
                "Laundry Worker + Driver (Couple)",
                "Maid + Gardener (Couple)",
                "Maid + Watchman (Couple)",
                "Maid + Security Guard (Couple)",
                "Maid + Maintenance Helper (Couple)",
                "Housekeeper + Gardener (Couple)",
                "Cleaner + Gardener (Couple)",
                "Nanny + Driver (Couple)",
                "Babysitter + Driver (Couple)",
                "Child Caregiver + Driver (Couple)",
                "Nanny + Gardener (Couple)",
                "Babysitter + Watchman (Couple)",
                "Caregiver + Driver (Couple)",
                "Home Nurse + Driver (Couple)",
                "Private Nurse + Driver (Couple)",
                "Elderly Caregiver + Driver (Couple)",
                "Caregiver + Watchman (Couple)",
                "Cook + Driver (Couple)",
                "Home Cook + Driver (Couple)",
                "Private Cook + Driver (Couple)",
                "Chef + Driver (Couple)",
                "Cook + Gardener (Couple)",
                "Maid + Cook (Couple)",
                "Maid + Babysitter (Couple)",
                "Maid + Caregiver (Couple)",
                "Cook + Caregiver (Couple)",
                "Cook + Babysitter (Couple)",
                "Maid + Housekeeper (Couple)",
                "Villa Caretaker Couple",
                "Estate Management Couple",
                "House Manager + Housekeeper (Couple)",
                "Butler + Housekeeper (Couple)",
                "Property Caretaker Couple",
                "Driver + Gardener (Couple)",
                "Driver + Watchman (Couple)",
                "Driver + Maintenance (Couple)",
                "Gardener + Watchman (Couple)",
                "Security Guard Couple",
                "Pet Caretaker + Driver (Couple)",
                "Home Beautician + Driver (Couple)"
        ],
        "Healthcare": [
                "Home Nurse",
                "House Nurse",
                "Home Care Nurse",
                "Hospital Nurse",
                "Physiotherapy",
                "Midwife (Midwifery)",
                "Any Nurse",
                "Nurse",
                "Clinic / Shop Nurse",
                "School Nurse",
                "Company / Industrial Nurse",
                "Elderly Care Nurse",
                "Special Care Nurse",
                "Emergency / Ambulance Nurse",
                "Lab / Assistant Nurse",
                "Hotel / Resort Nurse",
                "General Physician",
                "Specialist Doctor",
                "Consultant Doctor",
                "Resident Doctor",
                "Surgeon",
                "Internal Medicine Specialist",
                "Pediatrician",
                "Gynecologist",
                "Orthopedic Doctor",
                "Orthopedic Surgeon",
                "Cardiologist",
                "Neurologist",
                "Dermatologist",
                "Gastroenterologist",
                "Pulmonologist",
                "ENT Specialist",
                "Ophthalmologist (Eye Doctor)",
                "General Surgeon",
                "Neurosurgeon",
                "Cardiothoracic Surgeon",
                "Plastic Surgeon",
                "Urologist",
                "Anesthesiologist",
                "Radiologist",
                "Pathologist",
                "Psychiatrist",
                "Emergency Doctor",
                "Emergency Medicine Doctor",
                "ICU Doctor",
                "ICU Specialist",
                "Family Medicine Doctor",
                "Dental Doctor",
                "General Dentist",
                "Orthodontist",
                "Oral Surgeon",
                "Prosthodontist",
                "Medical Officer",
                "Registered Nurse"
        ],
        "Hospitality": [
                "Front Office / Reception",
                "Guest Relations",
                "Concierge",
                "Bell Boy / Porter",
                "Reservation Staff",
                "Host / Hostess",
                "Food Runner",
                "Restaurant Supervisor",
                "Captain / Head Waiter",
                "Chef (All Levels)",
                "Sous Chef",
                "Commis Chef",
                "Service Crew",
                "Room Attendant",
                "Public Area Cleaner",
                "Laundry Staff",
                "Housekeeping Supervisor",
                "Banquet Staff",
                "Event Setup Crew",
                "Catering Staff",
                "Event Coordinator",
                "Bartender",
                "Bar Assistant",
                "Beverage Server",
                "Juice / Mocktail Maker",
                "Resort Staff",
                "Pool Attendant",
                "Spa Receptionist",
                "Recreation Staff",
                "Cashier",
                "Cashier (Cafe)",
                "Counter Staff",
                "Waiter",
                "Waitress",
                "Barista",
                "Cafe Server",
                "Juice Maker",
                "Drive-Thru Operator",
                "Kitchen Crew",
                "Customer Service Assistant",
                "Kitchen Helper",
                "Pastry & Bakery Staff",
                "Line Cook",
                "Fry Cook",
                "Grill Cook",
                "Sandwich Maker",
                "Food Preparation Staff",
                "Cleaner",
                "Janitor",
                "Dishwasher",
                "Utility Staff",
                "Delivery Driver",
                "Delivery Rider",
                "Packing Staff",
                "Inventory Assistant",
                "Storekeeper",
                "Shift Supervisor",
                "Team Leader",
                "Floor Supervisor",
                "Hotel Manager",
                "Assistant Hotel Manager",
                "Duty Manager",
                "Resort Manager",
                "Front Office Manager",
                "Reception Supervisor",
                "Guest Relations Manager",
                "Concierge Manager",
                "F&B Manager",
                "Assistant Restaurant Manager",
                "Restaurant Manager",
                "Banquet Manager",
                "Catering Manager",
                "Executive Chef",
                "Kitchen Manager",
                "Pastry Chef",
                "Housekeeping Manager",
                "Laundry Manager",
                "Event Manager",
                "Banquet Supervisor",
                "Conference Manager",
                "Wedding Planner",
                "Operations Manager (Hospitality)",
                "Service Manager",
                "Outlet Manager",
                "HSE Manager (Hotel/Restaurant)",
                "Hygiene Manager",
                "Quality Assurance Manager",
                "Procurement Manager (Hotel/F&B)",
                "Store Manager (Hospitality)",
                "Inventory Controller",
                "Transport Coordinator",
                "Chauffeur Supervisor",
                "Guest Transport Manager",
                "Store Manager",
                "Area Manager"
        ],
        "Software / IT": [
                "Software Engineer",
                "Software Developer",
                "Full Stack Developer",
                "Frontend Developer",
                "Backend Developer",
                "Web Developer",
                "Mobile App Developer (iOS / Android)",
                "Game Developer",
                "Embedded Systems Developer",
                "UI Designer",
                "UX Designer",
                "UI/UX Developer",
                "Web Designer",
                "Graphic Designer",
                "Data Analyst",
                "Data Scientist",
                "Data Engineer",
                "Machine Learning Engineer",
                "AI Engineer",
                "Business Intelligence (BI) Developer",
                "Cybersecurity Specialist",
                "Information Security Analyst",
                "Network Engineer",
                "Network Administrator",
                "Security Engineer",
                "DevOps Engineer",
                "Cloud Engineer",
                "Cloud Architect",
                "Site Reliability Engineer (SRE)",
                "System Administrator",
                "QA Engineer",
                "Software Tester",
                "Automation Test Engineer",
                "Manual Tester",
                "Database Administrator (DBA)",
                "Database Developer",
                "SQL Developer",
                "IT Support Specialist",
                "Help Desk Technician",
                "Technical Support Engineer",
                "IT Technician",
                "IT Project Manager",
                "Product Manager",
                "Product Owner",
                "Scrum Master",
                "Technical Lead",
                "Engineering Manager",
                "Blockchain Developer",
                "AR/VR Developer",
                "IoT Engineer",
                "ERP Consultant (SAP, Oracle, etc.)",
                "CRM Developer (Salesforce, etc.)",
                "Junior Software Developer",
                "Intern (Software / IT)",
                "Trainee Engineer"
        ],
        "Construction": [
                "Construction Manager",
                "Project Manager",
                "Site Engineer",
                "Civil Engineer",
                "Mechanical Engineer",
                "Electrical Engineer",
                "Site Supervisor",
                "Foreman",
                "Quantity Surveyor",
                "Estimation Engineer",
                "Architect",
                "Draftsman / AutoCAD Draftsman",
                "Mason (Block / Plaster)",
                "Carpenter (Shuttering / Finishing)",
                "Steel Fixer",
                "Electrician",
                "Plumber",
                "Welder",
                "Painter",
                "Tile Mason",
                "Gypsum / Ceiling Technician",
                "HVAC Technician",
                "AC Technician",
                "JCB Operator",
                "Excavator Operator",
                "Bulldozer Operator",
                "Backhoe Operator",
                "Wheel Loader Operator",
                "Crane Operator",
                "Roller Operator",
                "Grader Operator",
                "General Labor / Helper",
                "Construction Helper",
                "Scaffolder",
                "Rigger",
                "Safety Officer (HSE)",
                "Timekeeper",
                "Storekeeper (Construction Site)",
                "Document Controller"
        ],
        "Retail & Sales": [
                "Sales Manager",
                "Assistant Sales Manager",
                "Sales Supervisor",
                "Sales Executive",
                "Sales Representative",
                "Sales Associate",
                "Retail Store Manager",
                "Assistant Store Manager",
                "Shop Supervisor",
                "Shop Salesman",
                "Saleslady",
                "Showroom Sales Executive",
                "Cashier",
                "Billing Executive",
                "Customer Service Representative",
                "Merchandiser",
                "Visual Merchandiser",
                "Promoter (In-store / Mall Promoter)",
                "Brand Ambassador",
                "Business Development Executive",
                "Key Account Manager",
                "Tele Sales Executive",
                "Call Center Sales Agent",
                "E-commerce Executive",
                "Online Sales Coordinator"
        ],
        "Cleaning & Maintenance": [
                "Cleaning Supervisor",
                "Housekeeping Supervisor",
                "Cleaner / General Cleaner",
                "Office Cleaner",
                "Housekeeper",
                "Room Attendant (Hotel)",
                "Public Area Cleaner",
                "Janitor",
                "Custodian",
                "Carpet Cleaner",
                "Window Cleaner",
                "Laundry Attendant",
                "Pressing / Ironing Staff",
                "Waste Management Worker",
                "Garbage Collector",
                "Pest Control Technician",
                "Cleaning Helper"
        ],
        "Company Worker": [
                "Driver",
                "Driver (Company / House)",
                "Light Driver",
                "Cook",
                "Cook (Company / House)",
                "Office Assistant",
                "Accountant",
                "HR Executive",
                "Admin Officer",
                "Public Relations Officer"
        ],
        "Manpower Agency": [
                "Recruiter",
                "Operations Manager",
                "Documentation Officer",
                "Agent"
        ],
        "Employer": [
                "Director",
                "Manager",
                "Business Owner",
                "Head of Department"
        ]
};

    // Lead Entry State - supports multiple emails & mobiles
    const [manualEntry, setManualEntry] = useState({
        category: '',
        jobPosition: '',
        ownerName: '',
        agencyName: '',
        country: 'Qatar',
        province: '',
        city: '',
        gender: '',
        age: '',
        religion: '',
        countryCode: '+974',
        emails: [''], // array of emails
        mobiles: [{ countryCode: '+974', number: '' }], // array of mobile objects
        website: '',
        youtube: '',
        instagram: '',
        facebook: '',
        source: 'manual',
        sourceKeyword: '',
        sourceLocation: '',
        sourcePlaceId: '',
        locationText: ''
    });

    const [extractorForm, setExtractorForm] = useState({
        keyword: '',
        currentLocation: 'Qatar',
        maxResults: 20,
        includeWebsiteEmail: true
    });
    const [extractorLoading, setExtractorLoading] = useState(false);
    const [extractorSaving, setExtractorSaving] = useState(false);
    const [extractorResults, setExtractorResults] = useState([]);
    const [extractorMeta, setExtractorMeta] = useState(null);
    const [selectedExtractorRowKeys, setSelectedExtractorRowKeys] = useState(new Set());

    // Editing state
    const [editingLeadId, setEditingLeadId] = useState(null);

    // DB-persisted leads
    const [leads, setLeads] = useState([]);
    const [leadsPage, setLeadsPage] = useState(1);
    const [leadsTotalPages, setLeadsTotalPages] = useState(1);
    const [leadsTotal, setLeadsTotal] = useState(0);
    const [leadsLoading, setLeadsLoading] = useState(false);
    const [leadsSearch, setLeadsSearch] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [jobPositionFilter, setJobPositionFilter] = useState('');
    const [currentCountryFilter, setCurrentCountryFilter] = useState('');
    const [provinceFilter, setProvinceFilter] = useState('');
    const [cityFilter, setCityFilter] = useState('');
    const [genderFilter, setGenderFilter] = useState('');
    const [ageFilter, setAgeFilter] = useState('');

    // Advanced Download modal state
    const [showAdvancedDownloadModal, setShowAdvancedDownloadModal] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);
    const [selectedExportFields, setSelectedExportFields] = useState(() => {
        const prefs = loadExportPrefs();
        if (prefs?.fields?.length) return prefs.fields;
        return ['agency_name', 'owner_name', 'emails', 'mobiles', 'country', 'category', 'job_position'];
    });
    const [selectedPhoneFormats, setSelectedPhoneFormats] = useState(() => {
        const prefs = loadExportPrefs();
        if (prefs?.formats?.length) return prefs.formats;
        return ['plus'];
    });
    const [downloadFileType, setDownloadFileType] = useState(() => {
        const prefs = loadExportPrefs();
        return prefs?.fileType === 'csv' ? 'csv' : 'xlsx';
    });
    const [defaultCountryCode, setDefaultCountryCode] = useState(() => {
        const prefs = loadExportPrefs();
        return prefs?.defaultCountryCode != null ? prefs.defaultCountryCode : '';
    });
    const [skipEmptyPhones, setSkipEmptyPhones] = useState(() => {
        const prefs = loadExportPrefs();
        return prefs?.skipEmptyPhones !== false;
    });
    const [phoneLayout, setPhoneLayout] = useState(() => {
        const prefs = loadExportPrefs();
        return prefs?.phoneLayout === 'wide' ? 'wide' : 'stacked';
    });

    // Selected leads for campaign
    const [selectedLeadIds, setSelectedLeadIds] = useState(new Set());

    // Campaign composer
    const [sending, setSending] = useState(false);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    // History with pagination
    const [history, setHistory] = useState([]);
    const [historyPage, setHistoryPage] = useState(1);
    const [historyTotalPages, setHistoryTotalPages] = useState(1);

    const [expandedRow, setExpandedRow] = useState(null);
    const [campaignRecipients, setCampaignRecipients] = useState({});
    const [loadingRecipients, setLoadingRecipients] = useState(false);
    const [adminProfile, setAdminProfile] = useState({ name: 'Admin', mobile: '+974 50783800', email: 'applyforqatar@gmail.com' });

    // WhatsApp Web JS State
    const [channels, setChannels] = useState({ email: true, whatsapp: false });
    const [waSession, setWaSession] = useState({ status: 'disconnected', initialized: false });
    const [waLimits, setWaLimits] = useState(null);
    const [loadingWaSession, setLoadingWaSession] = useState(false);
    const fileInputRef = useRef(null);
    const tableRef = useRef(null);

    // Draggable table logic
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        if (!tableRef.current) return;

        // Skip dragging if user clicks on interactive elements (checkboxes, buttons, etc.)
        const isInteractive = e.target.closest('button, input, select, a, .dropdown, .interactive-cell, .btn-link');
        if (isInteractive) return;

        // Prevent selection of text while dragging
        e.preventDefault();

        setIsDragging(true);
        setStartX(e.pageX - tableRef.current.offsetLeft);
        setScrollLeft(tableRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging || !tableRef.current) return;
        e.preventDefault();
        const x = e.pageX - tableRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed
        tableRef.current.scrollLeft = scrollLeft - walk;
    };

    // Template selection handler
    const handleSelectTemplate = (template) => {
        setSubject(template.subject);
        const htmlMsg = template.message.split('\n').map(line => line.trim() ? `<p>${line}</p>` : '').join('');
        setMessage(htmlMsg);
    };
    const [waQR, setWaQR] = useState(null);
    const [showQRModal, setShowQRModal] = useState(false);
    const [pendingUploadLeads, setPendingUploadLeads] = useState([]);
    const [showImportDefaultsModal, setShowImportDefaultsModal] = useState(false);
    const [importDefaults, setImportDefaults] = useState({ countryCode: '+974', category: '', jobPosition: '' });
    const [showPasteDataModal, setShowPasteDataModal] = useState(false);
    const [pasteLeadText, setPasteLeadText] = useState('');

    const LEADS_PER_PAGE = 10;
    const HISTORY_PER_PAGE = 10;
    const allJobPositionOptions = Array.from(new Set(Object.values(JOB_POSITIONS_BY_CATEGORY).flat())).sort((a, b) => a.localeCompare(b));
    const filteredJobPositionOptions = categoryFilter ? (JOB_POSITIONS_BY_CATEGORY[categoryFilter] || []) : allJobPositionOptions;
    const genderOptions = ['Male', 'Female', 'Other'];

    const fetchLeads = useCallback(async (
        page = 1,
        search = '',
        category = '',
        jobPosition = '',
        country = '',
        province = '',
        city = '',
        gender = '',
        age = ''
    ) => {
        setLeadsLoading(true);
        try {
            const res = await axios.get(`${BaseUrl}/api/admin/outreach/leads`, {
                params: {
                    page,
                    limit: LEADS_PER_PAGE,
                    search,
                    category,
                    job_position: jobPosition,
                    country,
                    province,
                    city,
                    gender,
                    age
                }
            });
            setLeads(res.data.leads || []);
            setLeadsTotalPages(res.data.totalPages || 1);
            setLeadsTotal(res.data.total || 0);
            setLeadsPage(res.data.page || 1);
        } catch (err) { console.error('Error fetching leads:', err); }
        finally { setLeadsLoading(false); }
    }, []);

    const fetchHistory = useCallback(async (page = 1) => {
        try {
            const res = await axios.get(`${BaseUrl}/api/admin/outreach/history`, {
                params: { page, limit: HISTORY_PER_PAGE }
            });
            const data = res.data;
            const logs = Array.isArray(data) ? data : (data.logs || []);
            setHistory(logs.filter(h => h.campaign_type === 'bulk' || h.campaign_type === 'external'));
            setHistoryTotalPages(data.totalPages || 1);
            setHistoryPage(data.page || page);
        } catch (err) { console.error('Error fetching history:', err); }
    }, []);

    useEffect(() => {
        fetchLeads(1, '', '', '', '', '', '', '', '');
        fetchHistory(1);
        fetchWaSession();
        fetchWaLimits();
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            setAdminProfile({
                name: `${user.first_name} ${user.last_name}`,
                mobile: user.mobile_number || '+974 50783800',
                email: user.email || 'applyforqatar@gmail.com'
            });
        }
    }, [fetchLeads, fetchHistory]);

    // Socket.IO for real-time campaign tracking
    useEffect(() => {
        const socket = io(BaseUrl, { transports: ['websocket', 'polling'] });

        socket.on('job_processed', (data) => {
            setHistory(prev => prev.map(h => {
                if (h.id === data.campaignId) {
                    const update = {};
                    if (data.channel === 'email') {
                        if (data.status === 'sent') update.sent_count = (Number(h.sent_count) || 0) + 1;
                        if (data.status === 'failed') update.failed_count = (Number(h.failed_count) || 0) + 1;
                    } else if (data.channel === 'whatsapp') {
                        if (data.status === 'sent') update.whatsapp_sent = (Number(h.whatsapp_sent) || 0) + 1;
                        if (data.status === 'failed') update.whatsapp_failed = (Number(h.whatsapp_failed) || 0) + 1;
                        if (data.status === 'skipped') update.whatsapp_skipped = (Number(h.whatsapp_skipped) || 0) + 1;
                    }
                    return { ...h, ...update };
                }
                return h;
            }));
        });

        socket.on('campaign_updated', (data) => {
            setHistory(prev => prev.map(h => h.id === data.campaignId ? { ...h, status: data.status } : h));
        });

        return () => socket.disconnect();
    }, []);

    // WA session polling when connecting/qr_required
    useEffect(() => {
        let interval;
        if (waSession.status === 'qr_required') {
            interval = setInterval(fetchWaSession, 20000);
        } else if (waSession.status === 'connecting') {
            interval = setInterval(fetchWaSession, 5000);
        }
        return () => interval && clearInterval(interval);
    }, [waSession.status]);

    // ── WhatsApp Session Management ──
    const fetchWaSession = async () => {
        setLoadingWaSession(true);
        try {
            const res = await axios.get(`${BaseUrl}/api/admin/outreach/whatsapp-session`);
            if (res.data.success) {
                setWaSession(res.data.session);
                if (res.data.session.status === 'qr_required') {
                    const qrRes = await axios.get(`${BaseUrl}/api/admin/outreach/whatsapp-session/qr`);
                    if (qrRes.data.success && qrRes.data.qr) setWaQR(qrRes.data.qr);
                }
            }
        } catch (err) { console.error('Failed to fetch WA session', err); }
        finally { setLoadingWaSession(false); }
    };

    const fetchWaLimits = async () => {
        try {
            const res = await axios.get(`${BaseUrl}/api/admin/outreach/whatsapp-limits`);
            if (res.data.success) setWaLimits(res.data.limits);
        } catch (err) { console.error('Failed to fetch WA limits', err); }
    };

    const startWaSession = async () => {
        try {
            const res = await axios.post(`${BaseUrl}/api/admin/outreach/whatsapp-session/start`);
            if (res.data.success) {
                Swal.fire({ icon: 'info', title: 'WhatsApp Starting...', text: 'Session is initializing. QR code will appear shortly.', timer: 2000, showConfirmButton: false });
                setWaSession(res.data.session);
                if (res.data.session.status === 'qr_required') setShowQRModal(true);
            } else {
                Swal.fire('Error', res.data.message || 'Failed to start session', 'error');
            }
        } catch (err) {
            Swal.fire('Error', err.response?.data?.message || 'Failed to start session', 'error');
        }
    };

    const logoutWaSession = async () => {
        try {
            await axios.post(`${BaseUrl}/api/admin/outreach/whatsapp-session/logout`);
            setWaSession({ status: 'disconnected', initialized: false });
            setWaQR(null);
            Swal.fire({ icon: 'success', title: 'Disconnected', text: 'WhatsApp session ended.', timer: 1500, showConfirmButton: false });
        } catch (err) {
            Swal.fire('Error', 'Failed to disconnect session', 'error');
        }
    };

    const toggleWhatsAppBlock = async (leadId, currentBlocked) => {
        try {
            const res = await axios.patch(`${BaseUrl}/api/admin/outreach/leads/${leadId}/whatsapp-block`, { blocked: !currentBlocked });
            if (res.data.success) {
                Swal.fire({ icon: 'success', title: `WhatsApp ${!currentBlocked ? 'Blocked' : 'Unblocked'}`, timer: 1200, showConfirmButton: false });
                fetchLeads(leadsPage, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
            }
        } catch (err) {
            Swal.fire('Error', 'Failed to update WhatsApp consent', 'error');
        }
    };

    // Helper for small contact action popover
    const renderContactPopover = (phone, prefilledMessage) => {
        const cleanPhone = phone.toString().replace(/[^0-9]/g, '');
        const plainMessage = prefilledMessage ? prefilledMessage.replace(/<[^>]*>?/gm, '') : '';
        
        return (
            <Popover id={`popover-${cleanPhone}-${Math.random().toString(36).substr(2, 5)}`} className="contact-popover shadow border-0">
                <Popover.Body className="p-2 d-flex flex-column gap-2" style={{ minWidth: '130px' }}>
                    <Button 
                        variant="primary" 
                        size="sm" 
                        className="d-flex align-items-center justify-content-center gap-2 py-2 fw-bold border-0"
                        onClick={() => { window.location.href = `tel:+${cleanPhone}`; }}
                    >
                        <FaPhone size={10} /> Call Now
                    </Button>
                    <Button 
                        variant="success" 
                        size="sm" 
                        className="d-flex align-items-center justify-content-center gap-2 py-2 fw-bold border-0"
                        style={{ backgroundColor: '#25D366' }}
                        onClick={() => {
                            const url = `https://wa.me/${cleanPhone}${plainMessage ? `?text=${encodeURIComponent(plainMessage)}` : ''}`;
                            window.open(url, '_blank');
                        }}
                    >
                        <FaWhatsapp size={12} /> WhatsApp
                    </Button>
                </Popover.Body>
            </Popover>
        );
    };

    const handleEmailAction = (email) => {
        window.location.href = `mailto:${email}`;
    };

    const toggleRow = async (id) => {
        if (expandedRow === id) { setExpandedRow(null); return; }
        setExpandedRow(id);
        if (!campaignRecipients[id]) {
            setLoadingRecipients(true);
            try {
                const res = await axios.get(`${BaseUrl}/api/admin/outreach/history/${id}/recipients`);
                setCampaignRecipients(prev => ({ ...prev, [id]: res.data }));
            } catch (err) { console.error(err); } finally { setLoadingRecipients(false); }
        }
    };

    // === Multi-email/mobile handlers ===
    const addEmailField = () => setManualEntry(prev => ({ ...prev, emails: [...prev.emails, ''] }));
    const removeEmailField = (idx) => setManualEntry(prev => ({ ...prev, emails: prev.emails.filter((_, i) => i !== idx) }));
    const updateEmail = (idx, val) => setManualEntry(prev => {
        const emails = [...prev.emails]; emails[idx] = val; return { ...prev, emails };
    });

    const addMobileField = () => setManualEntry(prev => ({ ...prev, mobiles: [...prev.mobiles, { countryCode: prev.countryCode, number: '' }] }));
    const removeMobileField = (idx) => setManualEntry(prev => ({ ...prev, mobiles: prev.mobiles.filter((_, i) => i !== idx) }));
    const updateMobile = (idx, field, val) => setManualEntry(prev => {
        const mobiles = [...prev.mobiles]; mobiles[idx] = { ...mobiles[idx], [field]: val }; return { ...prev, mobiles };
    });

    const handleParsePasteLead = () => {
        const parsed = parseOutreachPastedText(pasteLeadText);
        const parsedCountry = normalizePastedNationality(parsed.nationality || '');
        const nextCountry = parsedCountry || manualEntry.country;
        const nextCountryCode = extractCountryDialCode(nextCountry);
        const pastedNumbers = [
            ...(parsed.mobileNumbers || []),
            ...(parsed.whatsappNumbers || [])
        ];
        const nextMobiles = pastedNumbers
            .map(number => buildPastedMobile(number, nextCountryCode))
            .filter(mobile => mobile?.number);
        const nextEmails = Array.from(new Set(parsed.emails || []));
        const nextCategory = detectCategoryFromJobPosition(parsed.jobApplied || '');

        setManualEntry(prev => ({
            ...prev,
            category: nextCategory || prev.category,
            jobPosition: parsed.jobApplied || prev.jobPosition,
            country: nextCountry,
            province: parsedCountry ? '' : prev.province,
            city: parsedCountry ? '' : prev.city,
            countryCode: nextCountryCode,
            ownerName: parsed.name || prev.ownerName,
            gender: parsed.gender || prev.gender,
            age: parsed.age ? parsed.age.replace(/[^\d]/g, '') : prev.age,
            religion: parsed.religion || prev.religion,
            emails: nextEmails.length > 0 ? nextEmails : prev.emails,
            mobiles: nextMobiles.length > 0 ? nextMobiles : prev.mobiles
        }));

        setShowPasteDataModal(false);
        Swal.fire({
            icon: 'success',
            title: 'Pasted data filled',
            text: 'Review the lead fields, add Agency Name if needed, then save.',
            timer: 1800,
            showConfirmButton: false
        });
    };

    // Add or Update lead to DB
    const addLead = async (e, options = {}) => {
        e.preventDefault();
        const isEditingLead = Boolean(editingLeadId);
        const pageToRefresh = isEditingLead ? leadsPage : 1;
        const validEmails = manualEntry.emails.filter(em => em.trim() && EMAIL_REGEX.test(em.trim()));
        if (!manualEntry.agencyName || validEmails.length === 0) {
            return Swal.fire('Error', 'Agency name and at least one valid email are required.', 'error');
        }
        const validMobiles = manualEntry.mobiles.filter(m => m.number.trim());
        const payload = {
            agencyName: manualEntry.agencyName,
            category: manualEntry.category,
            job_position: manualEntry.jobPosition,
            ownerName: manualEntry.ownerName,
            country: manualEntry.country,
            province: manualEntry.province,
            city: manualEntry.city,
            gender: manualEntry.gender,
            age: manualEntry.age,
            religion: manualEntry.religion,
            emails: validEmails.map(e => e.trim()),
            mobiles: validMobiles,
            website: manualEntry.website,
            youtube_link: manualEntry.youtube,
            instagram_link: manualEntry.instagram,
            facebook_link: manualEntry.facebook,
            source: manualEntry.source || 'manual',
            sourceKeyword: manualEntry.sourceKeyword || '',
            sourceLocation: manualEntry.sourceLocation || '',
            sourcePlaceId: manualEntry.sourcePlaceId || '',
            locationText: manualEntry.locationText || '',
            allowDuplicateEmail: Boolean(options.allowDuplicateEmail)
        };
        try {
            if (editingLeadId) {
                await axios.put(`${BaseUrl}/api/admin/outreach/leads/${editingLeadId}`, payload);
                Swal.fire({ icon: 'success', title: 'Lead Updated!', text: `${manualEntry.agencyName} updated successfully.`, timer: 1500, showConfirmButton: false });
                setEditingLeadId(null);
            } else {
                await axios.post(`${BaseUrl}/api/admin/outreach/leads`, payload);
                Swal.fire({ icon: 'success', title: 'Lead Added!', text: `${manualEntry.agencyName} saved successfully.`, timer: 1500, showConfirmButton: false });
            }
            setManualEntry({
                category: manualEntry.category,
                jobPosition: '',
                ownerName: '',
                agencyName: '',
                country: 'Qatar',
                province: '',
                city: '',
                gender: '',
                age: '',
                religion: '',
                countryCode: '+974',
                emails: [''],
                mobiles: [{ countryCode: '+974', number: '' }],
                website: '',
                youtube: '',
                instagram: '',
                facebook: '',
                source: 'manual',
                sourceKeyword: '',
                sourceLocation: '',
                sourcePlaceId: '',
                locationText: ''
            });
            fetchLeads(pageToRefresh, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
        } catch (err) {
            if (!editingLeadId && err.response?.status === 409 && err.response?.data?.code === 'DUPLICATE_EMAIL' && !options.allowDuplicateEmail) {
                const existingLeadName = err.response?.data?.existingLeadName || 'another lead';
                const confirm = await Swal.fire({
                    title: 'Duplicate Email Found',
                    text: `This email already exists in lead: ${existingLeadName}. Do you want to continue and save anyway?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#198754'
                });

                if (confirm.isConfirmed) {
                    return addLead(e, { allowDuplicateEmail: true });
                }

                return;
            }

            Swal.fire('Error', err.response?.data?.error || 'Failed to save lead', 'error');
        }
    };
    // Edit lead - populate form
    const editLead = (lead) => {
        const emails = parseJson(lead.emails);
        const mobiles = parseJson(lead.mobiles);
        setEditingLeadId(lead.id);
        setManualEntry({
            category: lead.category || '',
            jobPosition: lead.job_position || '',
            agencyName: lead.agency_name || '',
            ownerName: lead.owner_name || '',
            country: lead.country || lead.current_location || 'Qatar',
            province: lead.province || '',
            city: lead.city || '',
            gender: lead.gender || '',
            age: lead.age || '',
            religion: lead.religion || '',
            countryCode: countryData.find(c => c.name === (lead.country || lead.current_location))?.dial_code || '+974',
            emails: emails.length > 0 ? emails : [''],
            mobiles: mobiles.length > 0 ? mobiles : [{ countryCode: '+974', number: '' }],
            website: lead.website || '',
            youtube: lead.youtube_link || '',
            instagram: lead.instagram_link || '',
            facebook: lead.facebook_link || '',
            source: lead.source || 'manual',
            sourceKeyword: lead.source_keyword || '',
            sourceLocation: lead.source_location || '',
            sourcePlaceId: lead.source_place_id || '',
            locationText: lead.location_text || ''
        });
    };

    // Cancel edit
    const cancelEdit = () => {
        setEditingLeadId(null);
        setManualEntry(prev => ({
            category: prev.category,
            jobPosition: '',
            ownerName: '',
            agencyName: '',
            country: 'Qatar',
            province: '',
            city: '',
            gender: '',
            age: '',
            religion: '',
            countryCode: '+974',
            emails: [''],
            mobiles: [{ countryCode: '+974', number: '' }],
            website: '',
            youtube: '',
            instagram: '',
            facebook: '',
            source: 'manual',
            sourceKeyword: '',
            sourceLocation: '',
            sourcePlaceId: '',
            locationText: ''
        }));
    };

    // Delete single lead
    const deleteLead = async (id) => {
        const confirm = await Swal.fire({ title: 'Delete Lead?', text: 'This action cannot be undone.', icon: 'warning', showCancelButton: true, confirmButtonText: 'Delete', confirmButtonColor: '#dc3545' });
        if (!confirm.isConfirmed) return;
        try {
            await axios.delete(`${BaseUrl}/api/admin/outreach/leads/${id}`);
            selectedLeadIds.delete(id);
            setSelectedLeadIds(new Set(selectedLeadIds));
            fetchLeads(leadsPage, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
        } catch (err) { Swal.fire('Error', 'Failed to delete lead', 'error'); }
    };

    // Clear all leads
    const clearAllLeads = async () => {
        const confirm = await Swal.fire({ 
            title: 'Clear ALL Leads?', 
            text: `This will permanently delete all ${leadsTotal} leads.`, 
            icon: 'warning', 
            showCancelButton: true, 
            confirmButtonText: 'Clear All', 
            confirmButtonColor: '#dc3545' 
        });

        if (!confirm.isConfirmed) return;

        const { value: password } = await Swal.fire({
            title: 'Password Required',
            text: 'Please enter the authorization password to clear all leads:',
            input: 'password',
            inputPlaceholder: 'Enter password',
            inputAttributes: {
                autocapitalize: 'off',
                autocorrect: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            confirmButtonColor: '#dc3545'
        });

        if (password === '3130') {
            try {
                await axios.delete(`${BaseUrl}/api/admin/outreach/leads`);
                setSelectedLeadIds(new Set());
                fetchLeads(1, '', categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
                Swal.fire({
                    icon: 'success',
                    title: 'Cleared!',
                    text: 'All leads have been deleted.',
                    timer: 1500,
                    showConfirmButton: false
                });
            } catch (err) { 
                Swal.fire('Error', 'Failed to clear leads', 'error'); 
            }
        } else if (password !== undefined) {
            Swal.fire('Access Denied', 'Incorrect password. Leads were not cleared.', 'error');
        }
      // Enhanced File upload (CSV/XLSX) -> save to DB
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const fileInput = e.target;
        const reader = new FileReader();

        reader.onload = async (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (jsonData.length === 0) {
                    Swal.fire('Error', 'File appears empty.', 'error');
                    fileInput.value = '';
                    return;
                }

                // Header analysis
                const firstRow = jsonData[0] || [];
                const normalizedFirstRow = firstRow.map(h => normalizeHeader(String(h || '')));
                
                const hasHeader = normalizedFirstRow.some(h =>
                    ['agency', 'company', 'email', 'mail', 'phone', 'mobile', 'owner', 'name', 'country', 'city', 'category', 'website'].some(t => h.includes(t))
                );

                const findCol = (targets) => {
                    // Try exact matches first
                    let idx = normalizedFirstRow.findIndex(h => targets.includes(h));
                    if (idx >= 0) return idx;
                    // Try partial matches, avoiding ad/campaign names when searching for generic 'name'
                    return normalizedFirstRow.findIndex(h => 
                        targets.some(t => h.includes(t) && (t !== 'name' || (!h.includes('adname') && !h.includes('campaignname'))))
                    );
                };

                const columns = hasHeader ? {
                    agency: findCol(['agencyname', 'companyname', 'agency', 'company']),
                    email: findCol(['email', 'mail']),
                    phone: findCol(['phone', 'mobile', 'contact', 'mobilenumber']),
                    whatsapp: findCol(['whatsapp', 'your_whatsapp_number', 'whatsappnumber', 'wp_number', 'wpnumber']),
                    owner: findCol(['fullname', 'ownername', 'username', 'person', 'owner', 'name']),
                    country: findCol(['country', 'nation', 'nationality', 'currentlocation', 'location']),
                    province: findCol(['province', 'state', 'region']),
                    city: findCol(['city', 'town', 'village']),
                    gender: findCol(['gender', 'sex']),
                    age: findCol(['age', 'dob', 'years']),
                    religion: findCol(['religion']),
                    jobPosition: findCol(['jobposition', 'position', 'role', 'designation']),
                    category: findCol(['category', 'type', 'industry']),
                    website: findCol(['website', 'site', 'url', 'web']),
                    youtube: findCol(['youtube', 'youtube_link']),
                    instagram: findCol(['instagram', 'instagram_link']),
                    facebook: findCol(['facebook', 'facebook_link'])
                } : null;

                const startRow = hasHeader ? 1 : 0;
                const newLeads = [];
                let invalidRows = 0;
                let anyMissingCountryCode = false;
                let anyMissingCategory = false;
                let anyMissingJobPosition = false;

                for (let rowIndex = startRow; rowIndex < jsonData.length; rowIndex++) {
                    const row = jsonData[rowIndex];
                    if (!row || row.length === 0) continue;

                    // 1. Extract Email (Mandatory)
                    const emailIndex = columns ? columns.email : 1;
                    const email = String(row[emailIndex] || (columns ? '' : (row[0] || ''))).trim().toLowerCase();
                    if (!EMAIL_REGEX.test(email)) { invalidRows++; continue; }

                    // 2. Extract Data only if mapped
                    const agencyName = columns && columns.agency >= 0 ? String(row[columns.agency] || '').trim() : '';
                    
                    // Unified Mobile Handling (Phone & WhatsApp)
                    const rawPhone = columns && columns.phone >= 0 ? String(row[columns.phone] || '').trim() : '';
                    const rawWA = columns && columns.whatsapp >= 0 ? String(row[columns.whatsapp] || '').trim() : '';
                    
                    const cleanNum = (val) => val.replace(/^p:/i, '').replace(/\s+/g, '').trim();
                    const phone = cleanNum(rawPhone);
                    const whatsapp = cleanNum(rawWA);

                    const ownerName = columns && columns.owner >= 0 ? String(row[columns.owner] || '').trim() : (columns ? '' : String(row[3] || '').trim());
                    const category = columns && columns.category >= 0 ? String(row[columns.category] || '').trim() : '';
                    const website = columns && columns.website >= 0 ? String(row[columns.website] || '').trim() : '';
                    const jobPos = columns && columns.jobPosition >= 0 ? String(row[columns.jobPosition] || '').trim() : '';
                    const gender = columns && columns.gender >= 0 ? String(row[columns.gender] || '').trim() : '';
                    const age = columns && columns.age >= 0 ? String(row[columns.age] || '').trim() : '';
                    const religion = columns && columns.religion >= 0 ? String(row[columns.religion] || '').trim() : '';
                    
                    const youtube = columns && columns.youtube >= 0 ? String(row[columns.youtube] || '').trim() : '';
                    const instagram = columns && columns.instagram >= 0 ? String(row[columns.instagram] || '').trim() : '';
                    const facebook = columns && columns.facebook >= 0 ? String(row[columns.facebook] || '').trim() : '';

                    // 3. Extract Location (Country/City)
                    const countryVal = columns && columns.country >= 0 ? String(row[columns.country] || '').trim() : '';
                    const cityVal = columns && columns.city >= 0 ? String(row[columns.city] || '').trim() : '';
                    
                    const mobiles = [];
                    if (phone) {
                        const hasCC = phone.startsWith('+');
                        if (!hasCC) anyMissingCountryCode = true;
                        mobiles.push({ countryCode: hasCC ? '' : null, number: phone });
                    }
                    if (whatsapp && whatsapp !== phone) {
                        const hasCC = whatsapp.startsWith('+');
                        if (!hasCC) anyMissingCountryCode = true;
                        mobiles.push({ countryCode: hasCC ? '' : null, number: whatsapp });
                    }

                    if (!category || category === 'General') anyMissingCategory = true;
                    if (!jobPos) anyMissingJobPosition = true;

                    newLeads.push({
                        agencyName: agencyName || 'N/A', 
                        ownerName: ownerName || 'N/A', 
                        country: countryVal || 'N/A',
                        province: columns && row[columns.province] ? String(row[columns.province]).trim() : '',
                        city: cityVal || '',
                        gender: gender || null,
                        age: age || null,
                        religion: religion || null,
                        job_position: jobPos || null,
                        category: category || null, 
                        website: website || '',
                        youtube_link: youtube || '',
                        instagram_link: instagram || '',
                        facebook_link: facebook || '',
                        source: 'import',
                        emails: [email],
                        mobiles: mobiles,
                        _needsDefaultMobile: mobiles.some(m => m.countryCode === null)
                    });
                }

                if (newLeads.length === 0) {
                    Swal.fire('Error', 'No valid rows found in file.', 'error');
                    fileInput.value = '';
                    return;
                }

                if (anyMissingCountryCode || anyMissingCategory || anyMissingJobPosition) {
                    setPendingUploadLeads(newLeads);
                    setShowImportDefaultsModal(true);
                } else {
                    await sendBulkLeads(newLeads, invalidRows);
                }

            } catch (err) {
                console.error('File import error:', err);
                Swal.fire('Error', 'Failed to parse file. Please ensure it is a valid CSV or Excel (.xlsx) file.', 'error');
            }
            fileInput.value = '';
        };

        reader.readAsArrayBuffer(file);
    };

    const sendBulkLeads = async (leadsToUpload, invalidRows) => {
        try {
            const res = await axios.post(`${BaseUrl}/api/admin/outreach/leads/bulk`, { leads: leadsToUpload });
            Swal.fire({
                icon: res.data.added > 0 ? 'success' : 'info',
                title: 'Import Result',
                text: `Successfully imported ${res.data.added} lead(s). Skipped ${res.data.skipped + (invalidRows || 0)} invalid or duplicate entries.`
            });
            fetchLeads(1, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
        } catch (err) {
            console.error('Bulk save failed:', err);
            Swal.fire('Error', 'Failed to save leads to database.', 'error');
        }
    };

    const processPendingUpload = async () => {
        const leadsToUpload = pendingUploadLeads.map(lead => {
            const updatedLead = { ...lead };
            
            // Apply default country code if missing
            if (updatedLead._needsDefaultMobile && updatedLead.mobiles.length > 0) {
                updatedLead.mobiles = updatedLead.mobiles.map(m => {
                    if (m.countryCode === null) {
                        const defaultCC = importDefaults.countryCode || '+63';
                        const cleanCC = defaultCC.replace('+', '');
                        // If number already starts with the country code digits (e.g. '63948...'),
                        // just prepend '+' and leave countryCode as empty to avoid duplication.
                        if (m.number.startsWith(cleanCC) && m.number.length > cleanCC.length + 5) {
                            return { ...m, countryCode: '', number: '+' + m.number };
                        }
                        return { ...m, countryCode: defaultCC };
                    }
                    return m;
                });
            }

            // Apply default category if missing
            if (!updatedLead.category || updatedLead.category === 'General') {
                updatedLead.category = importDefaults.category || 'General';
            }

            // Apply default job position if missing
            if (!updatedLead.job_position) {
                updatedLead.job_position = importDefaults.jobPosition || 'N/A';
            }

            delete updatedLead._needsDefaultMobile;
            return updatedLead;
        });

        setShowImportDefaultsModal(false);
        setPendingUploadLeads([]);
        await sendBulkLeads(leadsToUpload);
    };

    const handleExtractorSearch = async () => {
        if (!extractorForm.keyword.trim()) {
            return Swal.fire('Keyword Required', 'Enter a keyword to search on Google Places.', 'warning');
        }

        setExtractorLoading(true);
        try {
            const res = await axios.post(`${BaseUrl}/api/admin/outreach/extractor/search`, extractorForm);
            const rows = res.data.rows || [];
            setExtractorResults(rows);
            setExtractorMeta({
                query: res.data.query,
                returnedCount: res.data.returnedCount || rows.length,
                duplicateCount: res.data.duplicateCount || 0
            });
            setSelectedExtractorRowKeys(new Set(rows.filter(row => !row.isDuplicate).map(row => row.rowKey)));
        } catch (err) {
            console.error('Extractor search failed:', err);
            Swal.fire('Error', err.response?.data?.error || 'Failed to search Google Places leads.', 'error');
        } finally {
            setExtractorLoading(false);
        }
    };

    const toggleExtractorSelection = (rowKey) => {
        const next = new Set(selectedExtractorRowKeys);
        if (next.has(rowKey)) next.delete(rowKey);
        else next.add(rowKey);
        setSelectedExtractorRowKeys(next);
    };

    const toggleSelectAllExtractorRows = () => {
        const eligibleRowKeys = extractorResults.filter(row => !row.isDuplicate).map(row => row.rowKey);
        const allSelected = eligibleRowKeys.length > 0 && eligibleRowKeys.every(rowKey => selectedExtractorRowKeys.has(rowKey));
        setSelectedExtractorRowKeys(allSelected ? new Set() : new Set(eligibleRowKeys));
    };

    const exportExtractorPreview = () => {
        if (extractorResults.length === 0) {
            return Swal.fire('No Data', 'Run a search first to export preview data.', 'info');
        }

        const exportData = extractorResults.map((row, idx) => ({
            '#': idx + 1,
            'Keyword': row.keyword || '—',
            'Source Location': row.sourceLocation || '—',
            'Company Name': row.companyName || '—',
            'Category': row.category || '—',
            'Email': row.primaryEmail || '',
            'All Emails': (row.emails || []).join(', '),
            'Mobile': row.primaryMobile || '',
            'Website': row.website || '',
            'Address / Location': row.locationText || '',
            'Google Place ID': row.googlePlaceId || '',
            'Duplicate': row.isDuplicate ? (duplicateReasonLabel[row.duplicateBy] || 'Yes') : 'No'
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Extractor Preview');
        XLSX.writeFile(workbook, `GMap_Extractor_Preview_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const saveExtractorRows = async () => {
        const selectedRows = extractorResults.filter(row => selectedExtractorRowKeys.has(row.rowKey) && !row.isDuplicate);
        if (selectedRows.length === 0) {
            return Swal.fire('No Rows Selected', 'Select at least one non-duplicate row to save.', 'warning');
        }

        setExtractorSaving(true);
        try {
            const res = await axios.post(`${BaseUrl}/api/admin/outreach/extractor/save`, { rows: selectedRows });
            Swal.fire('Saved', `Inserted ${res.data.inserted} row(s). Skipped ${res.data.skipped}.`, 'success');
            setSelectedExtractorRowKeys(new Set());
            fetchLeads(1, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter);
            const refreshedRows = extractorResults.map((row) => (
                selectedRows.some(selected => selected.rowKey === row.rowKey)
                    ? { ...row, isDuplicate: true, duplicateBy: 'saved' }
                    : row
            ));
            setExtractorResults(refreshedRows);
        } catch (err) {
            console.error('Save extractor rows failed:', err);
            Swal.fire('Error', err.response?.data?.error || 'Failed to save extracted rows.', 'error');
        } finally {
            setExtractorSaving(false);
        }
    };

    // Select/deselect leads
    const toggleLeadSelection = (id) => {
        const newSet = new Set(selectedLeadIds);
        if (newSet.has(id)) newSet.delete(id); else newSet.add(id);
        setSelectedLeadIds(newSet);
    };
    const toggleSelectAllOnPage = () => {
        const pageIds = leads.map(l => l.id);
        const allSelected = pageIds.length > 0 && pageIds.every(id => selectedLeadIds.has(id));
        const newSet = new Set(selectedLeadIds);
        if (allSelected) { pageIds.forEach(id => newSet.delete(id)); }
        else { pageIds.forEach(id => newSet.add(id)); }
        setSelectedLeadIds(newSet);
    };

    const handleBatchSelect = async (count) => {
        try {
            setLeadsLoading(true);
            // Fetch the first 'count' leads according to the current sorting (last_sent_at ASC)
            const res = await axios.get(`${BaseUrl}/api/admin/outreach/leads`, {
                params: {
                    page: 1,
                    limit: count,
                    search: leadsSearch,
                    category: categoryFilter,
                    job_position: jobPositionFilter,
                    country: currentCountryFilter,
                    province: provinceFilter,
                    city: cityFilter,
                    gender: genderFilter,
                    age: ageFilter
                }
            });
            const batchIds = res.data.leads.map(l => l.id);
            setSelectedLeadIds(new Set(batchIds));

            Swal.fire({
                icon: 'success',
                title: 'Selection Updated',
                text: `${batchIds.length} oldest-contacted lead(s) selected.`,
                timer: 1500,
                showConfirmButton: false
            });
        } catch (err) {
            console.error('Error in batch selection:', err);
            Swal.fire('Error', 'Failed to perform batch selection', 'error');
        } finally {
            setLeadsLoading(false);
        }
    };

    // Send campaign to selected leads
    const handleSendCampaign = async () => {
        if (!subject || !message) return Swal.fire('Wait!', 'Please fill in both subject and message', 'warning');
        if (selectedLeadIds.size === 0) return Swal.fire('No Leads Selected', 'Select at least one lead to send.', 'warning');

        const selectedChannels = Object.entries(channels).filter(([, v]) => v).map(([k]) => k);
        if (selectedChannels.length === 0) return Swal.fire('No Channel', 'Select at least one delivery channel.', 'warning');

        if (selectedChannels.includes('whatsapp') && waSession.status !== 'connected') {
            return Swal.fire('WhatsApp Not Connected', 'Please connect WhatsApp before sending.', 'warning');
        }

        const channelLabel = selectedChannels.join(' + ').toUpperCase();
        const confirm = await Swal.fire({
            title: 'Launch Campaign?', text: `Send via ${channelLabel} to ${selectedLeadIds.size} selected lead(s)?`,
            icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes, Broadcast', confirmButtonColor: '#28a745'
        });
        if (!confirm.isConfirmed) return;
        setSending(true);
        try {
            await axios.post(`${BaseUrl}/api/admin/outreach/leads/send-campaign`, {
                leadIds: Array.from(selectedLeadIds), subject, message, adminInfo: adminProfile, channels: selectedChannels
            });
            Swal.fire('Success', `Campaign initiated via ${channelLabel}!`, 'success');
            setSubject(''); setMessage(''); setSelectedLeadIds(new Set());
            fetchHistory(1);
            if (selectedChannels.includes('whatsapp')) fetchWaLimits();
        } catch (err) { Swal.fire('Error', err.response?.data?.error || 'Failed to send campaign.', 'error'); }
        finally { setSending(false); }
    };

    // Helper to parse JSON fields from DB
    const parseJson = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') { try { return JSON.parse(val); } catch (e) { return []; } }
        return [];
    };

    // ── Advanced Download helpers ──
    const toggleExportField = (key) => {
        setSelectedExportFields(prev =>
            prev.includes(key) ? prev.filter(item => item !== key) : [...prev, key]
        );
    };

    const togglePhoneFormat = (key) => {
        setSelectedPhoneFormats(prev =>
            prev.includes(key) ? prev.filter(item => item !== key) : [...prev, key]
        );
    };

    const openAdvancedDownload = () => {
        setShowAdvancedDownloadModal(true);
    };

    const persistExportPrefs = (fields, formats, fileType) => {
        try {
            localStorage.setItem(EXPORT_PREFS_STORAGE_KEY, JSON.stringify({ fields, formats, fileType }));
        } catch (e) { /* storage may be unavailable; ignore */ }
    };

    const buildExportRows = (allLeads) => {
        const selectedFields = EXPORT_FIELD_OPTIONS.filter(f => selectedExportFields.includes(f.key));
        const includeMobile = selectedExportFields.includes('mobiles');
        const phoneColumnKeys = new Set();

        const formatLabelFor = (format) =>
            PHONE_FORMAT_OPTIONS.find(f => f.key === format)?.label || 'Number';

        // Build non-phone part of a row for a lead
        const buildBaseRow = (lead) => {
            const row = {};
            selectedFields.forEach((field) => {
                if (field.key === 'mobiles') return; // handled separately
                if (field.key === 'emails') {
                    const emails = parseJson(lead.emails);
                    row[field.label] = emails.join(', ');
                    return;
                }
                if (field.key === 'country') {
                    row[field.label] = lead.country || lead.current_location || '';
                    return;
                }
                if (field.key === 'created_at') {
                    row[field.label] = lead.created_at ? new Date(lead.created_at).toLocaleDateString() : '';
                    return;
                }
                row[field.label] = lead[field.key] != null ? String(lead[field.key]) : '';
            });
            return row;
        };

        // ── STACKED layout: each mobile entry becomes its own row ──
        if (includeMobile && phoneLayout === 'stacked') {
            const stackedRows = [];
            allLeads.forEach((lead) => {
                const baseRow = buildBaseRow(lead);
                const mobiles = parseJson(lead.mobiles);

                let anyEmittedForLead = false;
                mobiles.forEach((m) => {
                    const phoneRow = { ...baseRow };
                    let allFormatsEmpty = true;
                    selectedPhoneFormats.forEach((format) => {
                        const colName = `Phone Number (${formatLabelFor(format)})`;
                        phoneColumnKeys.add(colName);
                        const formatted = formatMobileForExport(m, format, defaultCountryCode);
                        phoneRow[colName] = formatted;
                        if (formatted) allFormatsEmpty = false;
                    });
                    if (skipEmptyPhones && allFormatsEmpty) return;
                    stackedRows.push(phoneRow);
                    anyEmittedForLead = true;
                });

                if (!anyEmittedForLead && !skipEmptyPhones) {
                    const placeholder = { ...baseRow };
                    selectedPhoneFormats.forEach((format) => {
                        const colName = `Phone Number (${formatLabelFor(format)})`;
                        phoneColumnKeys.add(colName);
                        placeholder[colName] = '';
                    });
                    stackedRows.push(placeholder);
                }
            });
            return { rows: stackedRows, phoneColumnKeys };
        }

        // ── WIDE layout: one column per (slot × format). Slot count = max mobiles across leads. ──
        const maxMobileSlots = includeMobile
            ? allLeads.reduce((max, lead) => Math.max(max, parseJson(lead.mobiles).length), 0)
            : 0;

        const rows = allLeads.map((lead) => {
            const row = buildBaseRow(lead);
            if (includeMobile && maxMobileSlots > 0) {
                const mobiles = parseJson(lead.mobiles);
                for (let i = 0; i < maxMobileSlots; i += 1) {
                    const m = mobiles[i];
                    selectedPhoneFormats.forEach((format) => {
                        const slotLabel = maxMobileSlots > 1 ? `Mobile ${i + 1}` : 'Mobile';
                        const colName = `${slotLabel} (${formatLabelFor(format)})`;
                        phoneColumnKeys.add(colName);
                        row[colName] = m ? formatMobileForExport(m, format, defaultCountryCode) : '';
                    });
                }
            }
            return row;
        });

        const filtered = (includeMobile && skipEmptyPhones && phoneColumnKeys.size > 0)
            ? rows.filter(row => Array.from(phoneColumnKeys).some(col => row[col] && String(row[col]).trim() !== ''))
            : rows;

        return { rows: filtered, phoneColumnKeys };
    };

    const handleAdvancedDownload = async () => {
        if (selectedExportFields.length === 0) {
            return Swal.fire('No Fields', 'Please select at least one field to download.', 'warning');
        }
        if (selectedExportFields.includes('mobiles') && selectedPhoneFormats.length === 0) {
            return Swal.fire('No Mobile Format', 'Please select at least one mobile format.', 'warning');
        }

        try {
            setDownloadInProgress(true);

            const res = await axios.get(`${BaseUrl}/api/admin/outreach/leads`, {
                params: {
                    page: 1,
                    limit: 99999,
                    search: leadsSearch,
                    category: categoryFilter,
                    job_position: jobPositionFilter,
                    country: currentCountryFilter,
                    province: provinceFilter,
                    city: cityFilter,
                    gender: genderFilter,
                    age: ageFilter
                }
            });
            const allLeads = res.data.leads || [];
            if (allLeads.length === 0) {
                setDownloadInProgress(false);
                return Swal.fire('No Data', 'No leads match the current filters.', 'info');
            }

            const { rows, phoneColumnKeys: mobileColumnKeys } = buildExportRows(allLeads);

            if (rows.length === 0) {
                setDownloadInProgress(false);
                return Swal.fire('No Rows', skipEmptyPhones
                    ? 'All matched leads have empty phone numbers. Turn off "Skip rows where every selected phone is empty" to include them.'
                    : 'No exportable rows were produced.', 'info');
            }

            const worksheet = XLSX.utils.json_to_sheet(rows);
            const headerKeys = Object.keys(rows[0] || {});

            // Force phone columns to TEXT so Excel preserves leading "+" and avoids scientific notation
            if (mobileColumnKeys.size > 0) {
                const range = XLSX.utils.decode_range(worksheet['!ref']);
                for (let C = range.s.c; C <= range.e.c; C += 1) {
                    const headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
                    if (!headerCell || !mobileColumnKeys.has(headerCell.v)) continue;
                    for (let R = 1; R <= range.e.r; R += 1) {
                        const addr = XLSX.utils.encode_cell({ r: R, c: C });
                        const cell = worksheet[addr];
                        if (!cell) continue;
                        cell.t = 's';
                        cell.v = String(cell.v == null ? '' : cell.v);
                        cell.z = '@';
                    }
                }
            }

            worksheet['!cols'] = headerKeys.map(key => ({
                wch: Math.max(key.length, ...rows.map(row => String(row[key] || '').length)) + 2
            }));

            const timestamp = new Date().toISOString().slice(0, 10);
            const filenameBase = `Gulfworker_Leads_${rows.length}_${timestamp}`;

            if (downloadFileType === 'csv') {
                // Wrap mobile values in ="..." so Excel preserves the leading "+" and treats them as text
                const csvRows = [headerKeys.join(',')];
                rows.forEach(row => {
                    const cells = headerKeys.map(key => {
                        const raw = row[key] == null ? '' : String(row[key]);
                        const escaped = raw.replace(/"/g, '""');
                        if (mobileColumnKeys.has(key) && raw) {
                            return `="${escaped}"`;
                        }
                        return /[",\n]/.test(raw) ? `"${escaped}"` : escaped;
                    });
                    csvRows.push(cells.join(','));
                });
                const csv = '﻿' + csvRows.join('\r\n');
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filenameBase}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else {
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');
                XLSX.writeFile(workbook, `${filenameBase}.xlsx`);
            }

            persistExportPrefs({
                fields: selectedExportFields,
                formats: selectedPhoneFormats,
                fileType: downloadFileType,
                defaultCountryCode,
                skipEmptyPhones,
                phoneLayout
            });
            setShowAdvancedDownloadModal(false);

            Swal.fire({
                icon: 'success',
                title: 'Downloaded!',
                text: `${rows.length} lead(s) exported.`,
                timer: 1800,
                showConfirmButton: false
            });
        } catch (err) {
            console.error('Export error:', err);
            Swal.fire('Error', 'Failed to export leads.', 'error');
        } finally {
            setDownloadInProgress(false);
        }
    };

    // Delete specific history log
    const deleteHistoryLog = async (id) => {
        const confirm = await Swal.fire({
            title: 'Delete Activity Log?',
            text: 'This will permanently remove this campaign record and its history.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete',
            confirmButtonColor: '#dc3545'
        });

        if (!confirm.isConfirmed) return;

        try {
            await axios.delete(`${BaseUrl}/api/admin/outreach/history/${id}`);
            Swal.fire({ icon: 'success', title: 'Deleted!', text: 'Campaign log removed.', timer: 1500, showConfirmButton: false });
            fetchHistory(historyPage);
        } catch (err) {
            Swal.fire('Error', 'Failed to delete activity log', 'error');
        }
    };

    // Clear all history logs
    const clearAllHistory = async () => {
        const confirm = await Swal.fire({
            title: 'Clear ALL Campaign History?',
            text: 'This will permanently delete all campaign activity records. This action is irreversible!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Clear All',
            confirmButtonColor: '#dc3545'
        });

        if (!confirm.isConfirmed) return;

        const { value: password } = await Swal.fire({
            title: 'Password Required',
            text: 'Enter authorization password to clear all history:',
            input: 'password',
            inputPlaceholder: 'Enter password',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            confirmButtonColor: '#dc3545'
        });

        if (password === '3130') {
            try {
                await axios.delete(`${BaseUrl}/api/admin/outreach/history`, { params: { type: 'bulk,external' } });
                fetchHistory(1);
                Swal.fire({ icon: 'success', title: 'Cleared!', text: 'Outreach activity history has been deleted.', timer: 1500, showConfirmButton: false });
            } catch (err) {
                Swal.fire('Error', 'Failed to clear history logs', 'error');
            }
        } else if (password !== undefined) {
            Swal.fire('Access Denied', 'Incorrect password.', 'error');
        }
    };

    // Search debounce
    useEffect(() => {
        const timer = setTimeout(() => fetchLeads(leadsPage, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter), 400);
        return () => clearTimeout(timer);
    }, [leadsPage, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter, fetchLeads]);

    return (
        <>
            <AdminNavbar />
            <div className="outreach-container" style={{ marginTop: '80px', paddingBottom: '50px' }}>
                <Container fluid>
                    <Row className="mb-4">
                        <Col lg={12}>
                            <Card className="outreach-card shadow-sm border-0">
                                <div className="outreach-header py-3 px-4 rounded-top d-flex justify-content-between align-items-center" style={{ background: 'linear-gradient(135deg, #0f766e 0%, #115e59 100%)' }}>
                                    <h5 className="mb-0 text-white"><FaGlobe className="me-2" /> Google Places Lead Extractor</h5>
                                    <Badge bg="light" text="dark">{extractorResults.length} Preview Row(s)</Badge>
                                </div>
                                <Card.Body className="p-4">
                                    <Row className="g-3 align-items-end">
                                        <Col lg={4}>
                                            <Form.Label className="small fw-bold">Keyword</Form.Label>
                                            <Form.Control
                                                className="bg-light"
                                                type="text"
                                                placeholder="e.g. recruitment agency, hospital, manpower company"
                                                value={extractorForm.keyword}
                                                onChange={(e) => setExtractorForm({ ...extractorForm, keyword: e.target.value })}
                                            />
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Label className="small fw-bold">Country</Form.Label>
                                            <SearchableDropdown
                                                options={countryData.map(c => ({ label: c.name, value: c.name, subtext: c.dial_code }))}
                                                value={extractorForm.country}
                                                onChange={(val) => setExtractorForm({ ...extractorForm, country: val })}
                                                placeholder="Search Country..."
                                            />
                                        </Col>
                                        <Col lg={2}>
                                            <Form.Label className="small fw-bold">Max Results</Form.Label>
                                            <Form.Select
                                                className="bg-light"
                                                value={extractorForm.maxResults}
                                                onChange={(e) => setExtractorForm({ ...extractorForm, maxResults: Number(e.target.value) })}
                                            >
                                                {[10, 20, 30, 50, 75, 100].map(limit => (
                                                    <option key={limit} value={limit}>{limit}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col lg={3}>
                                            <div className="extractor-switch-box">
                                                <Form.Check
                                                    type="switch"
                                                    id="website-email-enrichment"
                                                    label="Include website email enrichment"
                                                    checked={extractorForm.includeWebsiteEmail}
                                                    onChange={(e) => setExtractorForm({ ...extractorForm, includeWebsiteEmail: e.target.checked })}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <Button variant="success" className="fw-bold d-flex align-items-center" onClick={handleExtractorSearch} disabled={extractorLoading}>
                                            {extractorLoading ? <Spinner size="sm" className="me-2" /> : <FaSearch className="me-2" />}
                                            Search Google Places
                                        </Button>
                                        <Button variant="outline-primary" className="fw-bold" onClick={toggleSelectAllExtractorRows} disabled={extractorResults.filter(row => !row.isDuplicate).length === 0}>
                                            {selectedExtractorRowKeys.size > 0 ? 'Clear Selection' : 'Select All Non-Duplicates'}
                                        </Button>
                                        <Button variant="outline-success" className="fw-bold d-flex align-items-center" onClick={saveExtractorRows} disabled={extractorSaving || selectedExtractorRowKeys.size === 0}>
                                            {extractorSaving ? <Spinner size="sm" className="me-2" /> : <FaPlus className="me-2" />}
                                            Save Selected
                                        </Button>
                                        <Button variant="outline-secondary" className="fw-bold d-flex align-items-center" onClick={exportExtractorPreview} disabled={extractorResults.length === 0}>
                                            <FaFileExcel className="me-2" />
                                            Export Preview
                                        </Button>
                                    </div>

                                    {extractorMeta && (
                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                            <Badge bg="light" text="dark" className="border">Query: {extractorMeta.query}</Badge>
                                            <Badge bg="success">{extractorMeta.returnedCount} fetched</Badge>
                                            <Badge bg="warning" text="dark">{extractorMeta.duplicateCount} duplicate(s)</Badge>
                                            <Badge bg="info" text="dark">{selectedExtractorRowKeys.size} selected</Badge>
                                        </div>
                                    )}

                                    <div className="table-responsive rounded border mt-4 extractor-preview-table">
                                        <Table hover bordered className="mb-0 align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center" style={{ width: '44px' }}>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={extractorResults.filter(row => !row.isDuplicate).length > 0 && extractorResults.filter(row => !row.isDuplicate).every(row => selectedExtractorRowKeys.has(row.rowKey))}
                                                            onChange={toggleSelectAllExtractorRows}
                                                        />
                                                    </th>
                                                    <th>#</th>
                                                    <th>Keyword</th>
                                                    <th>Source Location</th>
                                                    <th>Company Name</th>
                                                    <th>Category</th>
                                                    <th>Email</th>
                                                    <th>Mobile</th>
                                                    <th>Website</th>
                                                    <th>Social Links</th>
                                                    <th>Address / Location</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {extractorLoading ? (
                                                    <tr><td colSpan="11" className="text-center py-5"><Spinner /></td></tr>
                                                ) : extractorResults.length > 0 ? (
                                                    extractorResults.map((row, idx) => {
                                                        const mobileLabel = (row.mobiles || []).map(m => `${m.countryCode || ''} ${m.number || ''}`.trim()).filter(Boolean).join(', ');
                                                        const duplicateLabel = duplicateReasonLabel[row.duplicateBy] || 'Duplicate';
                                                        return (
                                                            <tr key={row.rowKey} className={row.isDuplicate ? 'table-warning-subtle' : selectedExtractorRowKeys.has(row.rowKey) ? 'table-primary' : ''}>
                                                                <td className="text-center">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        checked={selectedExtractorRowKeys.has(row.rowKey)}
                                                                        onChange={() => toggleExtractorSelection(row.rowKey)}
                                                                        disabled={row.isDuplicate}
                                                                    />
                                                                </td>
                                                                <td>{idx + 1}</td>
                                                                <td>{row.keyword || '—'}</td>
                                                                <td><Badge bg="light" text="dark" className="border">{row.sourceLocation || '—'}</Badge></td>
                                                                <td className="fw-semibold">{row.companyName || '—'}</td>
                                                                <td>{row.category || '—'}</td>
                                                                <td className="small">
                                                                    {row.primaryEmail ? (
                                                                        <>
                                                                            <div>{row.primaryEmail}</div>
                                                                            {(row.emails || []).length > 1 && <div className="text-muted">{row.emails.length} emails found</div>}
                                                                        </>
                                                                    ) : <span className="text-muted">No email found</span>}
                                                                </td>
                                                                <td className="small">{mobileLabel || <span className="text-muted">No phone</span>}</td>
                                                                <td className="small">
                                                                    {row.website ? (
                                                                        <a href={row.website} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                                            {row.website.replace(/^https?:\/\/(www\.)?/i, '')}
                                                                        </a>
                                                                    ) : <span className="text-muted">No website</span>}
                                                                </td>
                                                                <td className="small">{row.locationText || '—'}</td>
                                                                <td>
                                                                    {row.isDuplicate ? (
                                                                        <Badge bg="warning" text="dark">{duplicateLabel}</Badge>
                                                                    ) : (
                                                                        <Badge bg="success">Ready to save</Badge>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr><td colSpan="11" className="text-center py-5 text-muted">Search by keyword and country to preview Google Places leads.</td></tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {/* LEFT: Lead Entry Form */}
                        <Col lg={5}>
                            <Card className={`outreach-card entry-card h-100 shadow-sm border-0 ${editingLeadId ? 'editing-mode' : ''}`}>
                                <div className={`outreach-header ${editingLeadId ? 'bg-warning' : 'bg-primary'} py-3 px-4 rounded-top d-flex justify-content-between align-items-center`}>
                                    <h5 className="mb-0 text-white">{editingLeadId ? <><FaEdit className="me-2" /> Editing Lead</> : <><FaPlus className="me-2" /> Add Agency Lead</>}</h5>
                                    {editingLeadId && (
                                        <Button variant="light" size="sm" className="fw-bold" onClick={cancelEdit}><FaTimes className="me-1" size={12} />Cancel</Button>
                                    )}
                                </div>
                                <Card.Body className="p-4 d-flex flex-column">
                                    <Form onSubmit={addLead} className="flex-grow-1 d-flex flex-column">
                                        {/* 1. Category & Job Position */}
                                        <Row className="g-3 mb-3">
                                            <Col md={6}>
                                                <Form.Label className="small fw-bold"><FaTag className="me-1 text-primary" size={12} /> Category</Form.Label>
                                                <Form.Select className="bg-light" value={manualEntry.category} onChange={e => setManualEntry({ ...manualEntry, category: e.target.value, jobPosition: '' })}>
                                                    <option value="">-- Select Category --</option>
                                                    {CATEGORY_OPTIONS.map((cat, idx) => (
                                                        <option key={idx} value={cat}>{cat}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Label className="small fw-bold">Job Position</Form.Label>
                                                <SearchableDropdown
                                                    options={manualEntry.category ? (JOB_POSITIONS_BY_CATEGORY[manualEntry.category] || []).map(pos => ({ label: pos, value: pos })) : []}
                                                    value={manualEntry.jobPosition}
                                                    onChange={(val) => setManualEntry({ ...manualEntry, jobPosition: val })}
                                                    placeholder="Search Position..."
                                                    disabled={!manualEntry.category}
                                                />
                                            </Col>
                                        </Row>

                                        {/* 2. Agency Name */}
                                        <Form.Group className="mb-3">
                                            <Form.Label className="small fw-bold">Agency Name <span className="text-danger">*</span></Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text className="bg-light border-end-0"><FaBuilding className="text-primary" size={14} /></InputGroup.Text>
                                                <Form.Control className="bg-light border-start-0" type="text" placeholder="Agency Name" value={manualEntry.agencyName} onChange={e => setManualEntry({ ...manualEntry, agencyName: e.target.value })} required />
                                            </InputGroup>
                                        </Form.Group>

                                        <Row className="g-3 mb-3">
                                            <Col md={12}>
                                                <Form.Label className="small fw-bold"><FaUser className="me-1 text-primary" size={12} /> Owner Name</Form.Label>
                                                <Form.Control className="bg-light" type="text" placeholder="John" value={manualEntry.ownerName} onChange={e => setManualEntry({ ...manualEntry, ownerName: e.target.value })} />
                                            </Col>
                                        </Row>

                                        {/* 4. Country + Province + City */}
                                        <Row className="g-3 mb-3">
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold"><FaGlobe className="me-1 text-primary" size={12} /> Country</Form.Label>
                                                <SearchableDropdown
                                                    options={countryData.map(c => ({ label: c.name, value: c.name, subtext: c.dial_code }))}
                                                    value={manualEntry.country}
                                                    onChange={(val) => {
                                                        const sel = countryData.find(c => c.name === val);
                                                        const nextCountryCode = sel?.dial_code || manualEntry.countryCode;
                                                        setManualEntry(prev => ({
                                                            ...prev,
                                                            country: val,
                                                            province: '', // Reset child
                                                            city: '',     // Reset child
                                                            countryCode: nextCountryCode,
                                                            mobiles: prev.mobiles.map(mob => ({
                                                                ...mob,
                                                                countryCode: nextCountryCode
                                                            }))
                                                        }));
                                                    }}
                                                    placeholder="Search Country..."
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold">Province</Form.Label>
                                                {countryStateCityData[manualEntry.country] ? (
                                                    <SearchableDropdown
                                                        options={Object.keys(countryStateCityData[manualEntry.country]).map(s => ({ label: s, value: s }))}
                                                        value={manualEntry.province}
                                                        onChange={(val) => setManualEntry(prev => ({ ...prev, province: val, city: '' }))}
                                                        placeholder="Search Province..."
                                                    />
                                                ) : (
                                                    <Form.Control 
                                                        className="bg-light" 
                                                        type="text" 
                                                        placeholder="Province" 
                                                        value={manualEntry.province} 
                                                        onChange={e => setManualEntry({ ...manualEntry, province: e.target.value })} 
                                                    />
                                                )}
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold">City</Form.Label>
                                                {manualEntry.province && countryStateCityData[manualEntry.country]?.[manualEntry.province] && countryStateCityData[manualEntry.country][manualEntry.province].length > 0 ? (
                                                    <SearchableDropdown
                                                        options={countryStateCityData[manualEntry.country][manualEntry.province].map(c => ({ label: c, value: c }))}
                                                        value={manualEntry.city}
                                                        onChange={(val) => setManualEntry(prev => ({ ...prev, city: val }))}
                                                        placeholder="Search City..."
                                                    />
                                                ) : (
                                                    <Form.Control 
                                                        className="bg-light" 
                                                        type="text" 
                                                        placeholder="City" 
                                                    />
                                                )}
                                            </Col>
                                        </Row>

                                        {/* Gender, Age & Religion */}
                                        <Row className="g-3 mb-3">
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold">Gender</Form.Label>
                                                <Form.Select className="bg-light" value={manualEntry.gender} onChange={e => setManualEntry({ ...manualEntry, gender: e.target.value })}>
                                                    <option value="">Select</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </Form.Select>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold">Age</Form.Label>
                                                <Form.Control className="bg-light" type="number" placeholder="25" value={manualEntry.age} onChange={e => setManualEntry({ ...manualEntry, age: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold">Religion</Form.Label>
                                                <Form.Control className="bg-light" type="text" placeholder="Catholic" value={manualEntry.religion} onChange={e => setManualEntry({ ...manualEntry, religion: e.target.value })} />
                                            </Col>
                                        </Row>

                                        {/* 5. Contact Numbers */}
                                        <Form.Group className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <Form.Label className="small fw-bold mb-0"><FaPhone className="me-1 text-primary" size={11} /> Contact Number(s)</Form.Label>
                                                <Button variant="link" size="sm" className="p-0 text-primary" onClick={addMobileField}><FaPlus size={10} className="me-1" />Add Number</Button>
                                            </div>
                                            {manualEntry.mobiles.map((mob, idx) => (
                                                <div key={idx} className="d-flex gap-2 mb-2 align-items-center outreach-contact-row">
                                                    <div style={{ flex: '0 0 120px' }} className="outreach-contact-code">
                                                        <SearchableDropdown
                                                            options={Array.from(new Set(countryData.map(c => c.dial_code))).sort().map(code => ({ label: code, value: code, subtext: countryData.find(c => c.dial_code === code)?.name }))}
                                                            value={mob.countryCode}
                                                            onChange={(val) => updateMobile(idx, 'countryCode', val)}
                                                            placeholder="Code"
                                                        />
                                                    </div>
                                                    <Form.Control className="bg-light outreach-contact-number-input" type="text" placeholder="50XX..." value={mob.number} onChange={e => updateMobile(idx, 'number', e.target.value)} />
                                                    {manualEntry.mobiles.length > 1 && (
                                                        <Button variant="link" className="text-danger p-0" onClick={() => removeMobileField(idx)}><FaTimes size={14} /></Button>
                                                    )}
                                                </div>
                                            ))}
                                        </Form.Group>

                                        {/* 6. Emails */}
                                        <Form.Group className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <Form.Label className="small fw-bold mb-0">Email(s) <span className="text-danger">*</span></Form.Label>
                                                <Button variant="link" size="sm" className="p-0 text-primary" onClick={addEmailField}><FaPlus size={10} className="me-1" />Add Email</Button>
                                            </div>
                                            {manualEntry.emails.map((email, idx) => (
                                                <div key={idx} className="d-flex gap-2 mb-2 align-items-center">
                                                    <InputGroup className="flex-grow-1">
                                                        <InputGroup.Text className="bg-light border-end-0"><FaEnvelopeOpenText className="text-primary" size={12} /></InputGroup.Text>
                                                        <Form.Control className="bg-light border-start-0" type="email" placeholder={`email${idx > 0 ? idx + 1 : ''}@agency.com`} value={email} onChange={e => updateEmail(idx, e.target.value)} required={idx === 0} />
                                                    </InputGroup>
                                                    {manualEntry.emails.length > 1 && (
                                                        <Button variant="link" className="text-danger p-0" onClick={() => removeEmailField(idx)}><FaTimes size={14} /></Button>
                                                    )}
                                                </div>
                                            ))}
                                        </Form.Group>

                                        {/* 7. Website & Social */}
                                        <Form.Group className="mb-3">
                                            <Form.Label className="small fw-bold"><FaLink className="me-1 text-primary" size={12} /> Website</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text className="bg-light border-end-0"><FaGlobe className="text-primary" size={14} /></InputGroup.Text>
                                                <Form.Control className="bg-light border-start-0" type="url" placeholder="https://www.agency.com" value={manualEntry.website} onChange={e => setManualEntry({ ...manualEntry, website: e.target.value })} />
                                            </InputGroup>
                                        </Form.Group>

                                        <Row className="g-2 mb-4">
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold"><FaFacebook className="me-1 text-primary" size={12} /> Facebook</Form.Label>
                                                <Form.Control className="bg-light" type="url" placeholder="Facebook Link" value={manualEntry.facebook} onChange={e => setManualEntry({ ...manualEntry, facebook: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold"><FaInstagram className="me-1" style={{ color: '#E1306C' }} size={12} /> Instagram</Form.Label>
                                                <Form.Control className="bg-light" type="url" placeholder="Instagram Link" value={manualEntry.instagram} onChange={e => setManualEntry({ ...manualEntry, instagram: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label className="small fw-bold"><FaYoutube className="me-1 text-danger" size={12} /> YouTube</Form.Label>
                                                <Form.Control className="bg-light" type="url" placeholder="YouTube Link" value={manualEntry.youtube} onChange={e => setManualEntry({ ...manualEntry, youtube: e.target.value })} />
                                            </Col>
                                        </Row>

                                        {/* Submit & Bulk Import Actions */}
                                        <div className="d-flex gap-2 mt-auto pt-3 border-top flex-wrap">
                                            <Button variant="outline-primary" onClick={() => setShowPasteDataModal(true)} className="flex-grow-1 fw-bold d-flex align-items-center justify-content-center" style={{ height: '42px' }}>
                                                <FaRegCommentDots className="me-2" /> Paste Data
                                            </Button>
                                            <Button variant="outline-success" onClick={() => fileInputRef.current.click()} className="flex-grow-1 fw-bold d-flex align-items-center justify-content-center" style={{ height: '42px' }}>
                                                <FaFileUpload className="me-2" /> Upload CSV / Excel Lead
                                            </Button>
                                            <Button variant="primary" type="submit" className="flex-grow-1 outreach-submit-btn fw-bold d-flex align-items-center justify-content-center" style={{ height: '42px' }}>
                                                {editingLeadId ? <><FaSave className="me-2" /> Update Lead Record</> : <><FaPlus className="me-2" /> Add Agency Lead</>}
                                            </Button>
                                            <input type="file" ref={fileInputRef} onChange={handleFileUpload} accept=".csv,.xlsx,.xls" style={{ display: 'none' }} />
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* RIGHT: Campaign Composer */}
                        <Col lg={7}>
                            <Card className="outreach-card composer-card h-100 shadow-sm border-0">
                                <div className="outreach-header bg-dark py-3 px-4 rounded-top d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0 text-white"><FaBroadcastTower className="me-2 text-info" /> Campaign Composer</h5>
                                    <Badge bg="info" className="text-dark">{selectedLeadIds.size} Lead(s) Selected</Badge>
                                </div>
                                <Card.Body className="p-4 d-flex flex-column">

                                    {/* ── Personalization Tags Helper ── */}
                                    <div className="mb-2 p-2 rounded bg-light border border-dashed">
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                            <FaRocket className="text-primary" size={12} />
                                            <span className="small fw-bold">Personalization Tags</span>
                                            <span className="text-muted" style={{ fontSize: '10px' }}>(Tags will be replaced with real data)</span>
                                        </div>
                                        <div className="d-flex flex-wrap gap-2">
                                            {['{name}', '{agency}', '{country}', '{email}', '{mobile}'].map(tag => (
                                                <Badge 
                                                    key={tag} 
                                                    bg="white" 
                                                    text="primary" 
                                                    className="border cursor-pointer hover-shadow-sm"
                                                    style={{ cursor: 'copy' }}
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(tag);
                                                    }}
                                                    title="Click to copy"
                                                >
                                                    {tag}
                                                </Badge>
                                            ))}
                                        </div>
                                    </div>

                                    {/* ── Delivery Channels ── */}
                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold"><FaBroadcastTower className="me-1 text-primary" size={11} /> Delivery Channels</Form.Label>
                                        <div className="d-flex gap-3 channels-group">
                                            <div
                                                className={`flex-fill d-flex align-items-center gap-2 p-3 rounded-3 border cursor-pointer wa-channel-toggle ${channels.email ? 'wa-channel-active-email' : 'border-light bg-light'}`}
                                                onClick={() => setChannels({ ...channels, email: !channels.email })}
                                            >
                                                <Form.Check type="checkbox" checked={channels.email} onChange={() => {}} className="m-0" />
                                                <FaEnvelope size={16} className={channels.email ? 'text-primary' : 'text-muted'} />
                                                <span className="fw-bold small">Email</span>
                                            </div>
                                            <div
                                                className={`flex-fill d-flex align-items-center gap-2 p-3 rounded-3 border cursor-pointer wa-channel-toggle ${channels.whatsapp ? 'wa-channel-active-whatsapp' : 'border-light bg-light'}`}
                                                onClick={() => setChannels({ ...channels, whatsapp: !channels.whatsapp })}
                                            >
                                                <Form.Check type="checkbox" checked={channels.whatsapp} onChange={() => {}} className="m-0" />
                                                <FaWhatsapp size={16} className={channels.whatsapp ? 'text-success' : 'text-muted'} />
                                                <span className="fw-bold small">WhatsApp</span>
                                            </div>
                                        </div>
                                    </Form.Group>

                                    {/* ── WhatsApp Session Status ── */}
                                    {channels.whatsapp && (
                                        <div className="wa-session-card mb-3 p-3 rounded-3 border d-flex align-items-center justify-content-between" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className={`wa-status-dot ${waSession.status === 'connected' ? 'wa-dot-connected' : waSession.status === 'connecting' ? 'wa-dot-connecting' : 'wa-dot-disconnected'}`} />
                                                <div>
                                                    <div className="fw-bold small text-capitalize">{waSession.status.replace('_', ' ')}</div>
                                                    {waLimits && (
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                                            {waLimits.dailyLimit} daily limit · {waLimits.remaining} remaining · {waLimits.minDelayMs/1000}s-{waLimits.maxDelayMs/1000}s delay
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <Button variant="outline-secondary" size="sm" onClick={fetchWaSession} title="Refresh Status">
                                                    <FaSync size={12} className={loadingWaSession ? 'fa-spin' : ''} />
                                                </Button>
                                                {(waSession.status === 'disconnected' || waSession.status === 'error') && (
                                                    <Button variant="success" size="sm" className="fw-bold d-flex align-items-center gap-1" onClick={startWaSession}>
                                                        <FaWhatsapp size={14} /> Connect
                                                    </Button>
                                                )}
                                                {waSession.status === 'qr_required' && (
                                                    <Button variant="dark" size="sm" className="fw-bold d-flex align-items-center gap-1" onClick={() => setShowQRModal(true)}>
                                                        <FaQrcode size={14} /> Scan QR
                                                    </Button>
                                                )}
                                                {waSession.status === 'connected' && (
                                                    <Button variant="outline-danger" size="sm" className="fw-bold d-flex align-items-center gap-1" onClick={logoutWaSession}>
                                                        <FaSignOutAlt size={12} /> Disconnect
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* ── Campaign Template Selection ── */}
                                    <Form.Group className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <Form.Label className="small fw-bold mb-0">
                                                <FaTag className="me-1 text-primary" size={11} /> Quick Templates
                                            </Form.Label>
                                            {(subject || message) && (
                                                <Button 
                                                    variant="link" 
                                                    className="p-0 text-danger text-decoration-none small" 
                                                    style={{ fontSize: '11px' }}
                                                    onClick={() => { setSubject(''); setMessage(''); }}
                                                >
                                                    Clear Composer
                                                </Button>
                                            )}
                                        </div>
                                        <Form.Select 
                                            className="bg-light border-0" 
                                            style={{ fontSize: '13px', height: '40px' }}
                                            onChange={(e) => {
                                                const template = CAMPAIGN_TEMPLATES.find(t => t.id === e.target.value);
                                                if (template) handleSelectTemplate(template);
                                            }}
                                            value=""
                                        >
                                            <option value="" disabled>Choose a pre-defined template...</option>
                                            {CAMPAIGN_TEMPLATES.map(t => (
                                                <option key={t.id} value={t.id}>{t.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold">Subject Line {channels.whatsapp && !channels.email ? <span className="text-muted fw-normal">(used as reference only for WA)</span> : ''}</Form.Label>
                                        <Form.Control type="text" placeholder="Campaign Subject" className="p-3 bg-light" value={subject} onChange={e => setSubject(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-0 flex-grow-1 d-flex flex-column pb-3 quill-container">
                                        <Form.Label className="small fw-bold">HTML Message {channels.whatsapp && <span className="text-muted fw-normal">(HTML stripped for WhatsApp)</span>}</Form.Label>
                                        <ReactQuill
                                            theme="snow"
                                            value={message}
                                            onChange={setMessage}
                                            placeholder="Write your message here..."
                                            className="flex-grow-1 d-flex flex-column"
                                            style={{ height: '300px', marginBottom: '45px' }}
                                            modules={{
                                                toolbar: [
                                                    ['bold', 'italic', 'underline'],
                                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                    [{ 'script': 'sub' }, { 'script': 'super' }],
                                                    [{ 'size': ['small', false, 'large', 'huge'] }],
                                                    ['clean']
                                                ]
                                            }}
                                        />
                                    </Form.Group>
                                    <div className="mt-auto pt-3" style={{ borderTop: 'none' }}>
                                        <Button variant="success" className="w-100 fw-bold shadow-sm d-flex align-items-center justify-content-center" style={{ height: '44px' }} onClick={handleSendCampaign} disabled={sending || selectedLeadIds.size === 0}>
                                            {sending ? <Spinner size="sm" className="me-2" /> : <FaBroadcastTower className="me-2" />}
                                            Broadcast to {selectedLeadIds.size} Selected Lead(s)
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* LEADS TABLE (DB-persisted) */}
                    <Row className="mt-4">
                        <Col lg={12}>
                            <Card className="outreach-card shadow-sm border-0">
                                <div className="outreach-header bg-primary py-3 px-4 d-flex justify-content-between align-items-center rounded-top flex-wrap gap-3">
                                    <h5 className="mb-0 text-white"><FaUsers className="me-2" /> Stored Leads ({leadsTotal})</h5>
                                    <div className="d-flex gap-2 align-items-center flex-wrap">
                                        <div className="d-flex align-items-center bg-white rounded px-2" style={{ height: '32px', width: '180px', border: '1px solid #dee2e6' }}>
                                            <FaSearch size={12} className="text-muted me-2" />
                                            <input
                                                type="text"
                                                className="border-0 w-100"
                                                style={{ fontSize: '13px', outline: 'none', background: 'transparent' }}
                                                placeholder="Search leads..."
                                                value={leadsSearch}
                                                onChange={e => setLeadsSearch(e.target.value)}
                                            />
                                        </div>
                                        <Button
                                            variant="success"
                                            size="sm"
                                            className="text-nowrap d-flex align-items-center justify-content-center fw-bold gap-1"
                                            style={{ height: '32px', fontSize: '12px', minWidth: '140px' }}
                                            onClick={openAdvancedDownload}
                                            disabled={leadsTotal === 0}
                                            title="Choose fields and mobile formats before downloading"
                                        >
                                            <FaDownload size={12} /> Advanced Download
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            className="text-nowrap d-flex align-items-center justify-content-center fw-bold"
                                            style={{ height: '32px', fontSize: '12px', minWidth: '80px' }}
                                            onClick={clearAllLeads}
                                            disabled={leadsTotal === 0}
                                        >
                                            Clear All
                                        </Button>
                                    </div>
                                </div>


                                {/* Filters Row */}
                                <div className="d-flex gap-3 align-items-center px-4 py-3 bg-light border-bottom flex-wrap" style={{ borderTop: '1px solid #e2e8f0' }}>
                                    <div className="d-flex align-items-center gap-2">
                                        <FaFilter size={12} className="text-primary" />
                                        <span className="small fw-bold text-muted text-uppercase" style={{ letterSpacing: '0.5px' }}>Filters:</span>
                                    </div>
                                    <Form.Select
                                        size="sm"
                                        className="bg-white"
                                        style={{ width: '180px', fontSize: '13px' }}
                                        value={categoryFilter}
                                        onChange={e => {
                                            const nextCategory = e.target.value;
                                            setCategoryFilter(nextCategory);
                                            setJobPositionFilter('');
                                            setLeadsPage(1);
                                        }}
                                    >
                                        <option value="">All Categories</option>
                                        {CATEGORY_OPTIONS.map((cat, idx) => (
                                            <option key={idx} value={cat}>{cat}</option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select
                                        size="sm"
                                        className="bg-white"
                                        style={{ width: '180px', fontSize: '13px' }}
                                        value={jobPositionFilter}
                                        onChange={e => { setJobPositionFilter(e.target.value); setLeadsPage(1); }}
                                    >
                                        <option value="">All Positions</option>
                                        {filteredJobPositionOptions.map((position, idx) => (
                                            <option key={idx} value={position}>{position}</option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select
                                        size="sm"
                                        className="bg-white"
                                        style={{ width: '180px', fontSize: '13px' }}
                                        value={currentCountryFilter}
                                        onChange={e => { 
                                            setCurrentCountryFilter(e.target.value); 
                                            setProvinceFilter(''); 
                                            setCityFilter('');
                                            setLeadsPage(1); 
                                        }}
                                    >
                                        <option value="">Country</option>
                                        {countryData.map(c => c.name).sort().map((c, idx) => (
                                            <option key={idx} value={c}>{c}</option>
                                        ))}
                                    </Form.Select>
                                    
                                    {currentCountryFilter && countryStateCityData[currentCountryFilter] ? (
                                        <Form.Select
                                            size="sm"
                                            className="bg-white"
                                            style={{ width: '180px', fontSize: '13px' }}
                                            value={provinceFilter}
                                            onChange={e => { setProvinceFilter(e.target.value); setCityFilter(''); setLeadsPage(1); }}
                                        >
                                            <option value="">All Provinces</option>
                                            {Object.keys(countryStateCityData[currentCountryFilter]).sort().map((s, idx) => (
                                                <option key={idx} value={s}>{s}</option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            size="sm"
                                            className="bg-white"
                                            style={{ width: '140px', fontSize: '13px' }}
                                            type="text"
                                            placeholder="Province"
                                            value={provinceFilter}
                                            onChange={e => { setProvinceFilter(e.target.value); setLeadsPage(1); }}
                                        />
                                    )}

                                    {provinceFilter && countryStateCityData[currentCountryFilter]?.[provinceFilter] ? (
                                        <Form.Select
                                            size="sm"
                                            className="bg-white"
                                            style={{ width: '180px', fontSize: '13px' }}
                                            value={cityFilter}
                                            onChange={e => { setCityFilter(e.target.value); setLeadsPage(1); }}
                                        >
                                            <option value="">All Cities</option>
                                            {countryStateCityData[currentCountryFilter][provinceFilter].sort().map((c, idx) => (
                                                <option key={idx} value={c}>{c}</option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            size="sm"
                                            className="bg-white"
                                            style={{ width: '140px', fontSize: '13px' }}
                                            type="text"
                                            placeholder="City"
                                            value={cityFilter}
                                            onChange={e => { setCityFilter(e.target.value); setLeadsPage(1); }}
                                        />
                                    )}
                                    <Form.Select
                                        size="sm"
                                        className="bg-white"
                                        style={{ width: '140px', fontSize: '13px' }}
                                        value={genderFilter}
                                        onChange={e => { setGenderFilter(e.target.value); setLeadsPage(1); }}
                                    >
                                        <option value="">Gender</option>
                                        {genderOptions.map((gender, idx) => (
                                            <option key={idx} value={gender}>{gender}</option>
                                        ))}
                                    </Form.Select>
                                    <Form.Control
                                        size="sm"
                                        className="bg-white"
                                        style={{ width: '110px', fontSize: '13px' }}
                                        type="number"
                                        min="0"
                                        placeholder="Age"
                                        value={ageFilter}
                                        onChange={e => { setAgeFilter(e.target.value); setLeadsPage(1); }}
                                    />
                                    {(categoryFilter || jobPositionFilter || currentCountryFilter || provinceFilter || cityFilter || genderFilter || ageFilter || leadsSearch) && (
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="small py-0 px-2"
                                            style={{ fontSize: '12px', height: '28px' }}
                                            onClick={() => {
                                                setCategoryFilter('');
                                                setJobPositionFilter('');
                                                setCurrentCountryFilter('');
                                                setProvinceFilter('');
                                                setCityFilter('');
                                                setGenderFilter('');
                                                setAgeFilter('');
                                                setLeadsSearch('');
                                                setLeadsPage(1);
                                            }}
                                        >
                                            <FaTimes size={10} className="me-1" />Clear All
                                        </Button>
                                    )}
                                </div>

                                <Card.Body className="p-0">
                                    <div 
                                        className={`table-responsive leads-table-responsive ${isDragging ? 'is-dragging' : ''}`}
                                        ref={tableRef}
                                        onMouseDown={handleMouseDown}
                                        onMouseLeave={handleMouseLeave}
                                        onMouseUp={handleMouseUp}
                                        onMouseMove={handleMouseMove}
                                    >
                                        <Table hover bordered className="mb-0 leads-bordered-table">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center" style={{ width: '40px', minWidth: '40px' }}>
                                                        <Dropdown className="d-flex justify-content-center align-items-center">
                                                            <Dropdown.Toggle as="div" className="cursor-pointer d-flex align-items-center justify-content-center" style={{ whiteSpace: 'nowrap' }}>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    checked={leads.length > 0 && leads.every(l => selectedLeadIds.has(l.id))}
                                                                    onChange={(e) => { e.stopPropagation(); toggleSelectAllOnPage(); }}
                                                                    style={{ margin: 0 }}
                                                                />
                                                                <span className="text-muted ms-1" style={{ fontSize: '9px' }}>▼</span>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="shadow-sm border-0 mt-2" popperConfig={{ strategy: 'fixed' }}>
                                                                <Dropdown.Header className="small fw-bold text-primary">Select Leads</Dropdown.Header>
                                                                <Dropdown.Item onClick={() => handleBatchSelect(10)} className="small py-2">Select Next 10</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleBatchSelect(20)} className="small py-2">Select Next 20</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleBatchSelect(30)} className="small py-2">Select Next 30</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleBatchSelect(40)} className="small py-2">Select Next 40</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleBatchSelect(50)} className="small py-2">Select Next 50</Dropdown.Item>
                                                                <Dropdown.Divider />
                                                                <Dropdown.Item onClick={() => handleBatchSelect(leadsTotal)} className="small py-2 fw-bold text-success">Select All ({leadsTotal})</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => setSelectedLeadIds(new Set())} className="small py-2 text-danger">Clear Selection</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </th>
                                                    <th style={{ width: '40px' }}>#</th>
                                                    <th>Category</th>
                                                    <th>Position</th>
                                                    <th>Agency</th>
                                                    <th>Owner Name</th>
                                                    <th>Country</th>
                                                    <th>Province</th>
                                                    <th>City</th>
                                                    <th>Gender/Age</th>
                                                    <th>Religion</th>
                                                    <th>Mobile(s)</th>
                                                    <th>Email(s)</th>
                                                    <th>Website</th>
                                                    <th>Social Links</th>
                                                    <th>Added</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leadsLoading ? (
                                                    <tr><td colSpan="17" className="text-center py-5"><Spinner size="sm" /></td></tr>
                                                ) : leads.length > 0 ? leads.map((lead, i) => {
                                                    const emails = parseJson(lead.emails);
                                                    const mobiles = parseJson(lead.mobiles);
                                                    return (
                                                        <tr key={lead.id} className={selectedLeadIds.has(lead.id) ? 'table-primary' : ''}>
                                                            <td className="text-center p-0" style={{ width: '40px', minWidth: '40px' }}>
                                                                <div className="d-flex align-items-center justify-content-center" style={{ height: '40px' }}>
                                                                    <Form.Check type="checkbox" checked={selectedLeadIds.has(lead.id)} onChange={() => toggleLeadSelection(lead.id)} style={{ margin: 0 }} />
                                                                </div>
                                                            </td>
                                                            <td className="text-muted small">{(leadsPage - 1) * LEADS_PER_PAGE + i + 1}</td>
                                                            <td className="text-capitalize">
                                                                <div className="fw-bold">{lead.category || '—'}</div>
                                                            </td>
                                                            <td className="small">{lead.job_position || '—'}</td>
                                                            <td className="fw-bold">{lead.agency_name}</td>
                                                            <td className="small">{lead.owner_name || '—'}</td>
                                                            <td><Badge bg="light" text="dark" className="border">{lead.country || lead.current_location || '—'}</Badge></td>
                                                            <td className="small">{lead.province || '—'}</td>
                                                            <td className="small">{lead.city || '—'}</td>
                                                            <td className="small">
                                                                {lead.gender || '—'} / {lead.age || '—'}
                                                            </td>
                                                            <td className="small">{lead.religion || '—'}</td>
                                                            <td>
                                                                {mobiles.length > 0 ? mobiles.map((m, mi) => (
                                                                    <React.Fragment key={mi}>
                                                                        <OverlayTrigger
                                                                            trigger="click"
                                                                            rootClose
                                                                            placement="auto"
                                                                            container={document.body}
                                                                            overlay={renderContactPopover(`${m.countryCode}${m.number}`, '')}
                                                                        >
                                                                            <div className="small interactive-cell contact-cell d-inline-block px-1 rounded uppercase" style={{ cursor: 'pointer', minHeight: '24px' }}>{m.countryCode} {m.number}</div>
                                                                        </OverlayTrigger>
                                                                        {(mi + 1) % 3 === 0 && mi !== mobiles.length - 1 && <br />}
                                                                    </React.Fragment>
                                                                )) : '—'}
                                                            </td>
                                                            <td>
                                                                {emails.map((em, ei) => (
                                                                    <div key={ei} className="small interactive-cell" onClick={() => handleEmailAction(em)} title="Send Email">{em}</div>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                {lead.website ? (
                                                                    <a href={lead.website} target="_blank" rel="noopener noreferrer" className="small text-primary text-decoration-none">{lead.website.replace(/^https?:\/\/(www\.)?/, '').slice(0, 25)}{lead.website.length > 30 ? '...' : ''}</a>
                                                                ) : '—'}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex gap-2">
                                                                    {lead.youtube_link && (
                                                                        <a href={lead.youtube_link} target="_blank" rel="noopener noreferrer" className="text-danger" title="YouTube"><FaYoutube size={16} /></a>
                                                                    )}
                                                                    {lead.instagram_link && (
                                                                        <a href={lead.instagram_link} target="_blank" rel="noopener noreferrer" style={{ color: '#E1306C' }} title="Instagram"><FaInstagram size={16} /></a>
                                                                    )}
                                                                    {lead.facebook_link && (
                                                                        <a href={lead.facebook_link} target="_blank" rel="noopener noreferrer" className="text-primary" title="Facebook"><FaFacebook size={16} /></a>
                                                                    )}
                                                                    {!lead.youtube_link && !lead.instagram_link && !lead.facebook_link && <span className="text-muted small">—</span>}
                                                                </div>
                                                            </td>
                                                            <td className="small text-muted">{new Date(lead.created_at).toLocaleDateString()}</td>
                                                            <td className="text-center">
                                                                <div className="d-flex gap-2 justify-content-center">
                                                                    <Button variant="link" className="text-primary p-0" title="Edit Lead" onClick={() => editLead(lead)}><FaEdit size={14} /></Button>
                                                                    <Button variant="link" className="text-danger p-0" title="Delete Lead" onClick={() => deleteLead(lead.id)}><FaTrash size={14} /></Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }) : (
                                                    <tr><td colSpan="17" className="text-center py-5 text-muted">No leads stored yet. Add leads above or import a CSV.</td></tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <PaginationControls currentPage={leadsPage} totalPages={leadsTotalPages} onPageChange={(p) => fetchLeads(p, leadsSearch, categoryFilter, jobPositionFilter, currentCountryFilter, provinceFilter, cityFilter, genderFilter, ageFilter)} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* CAMPAIGN ACTIVITY LOGS */}
                    <Row className="mt-5">
                        <Col lg={12}>
                            <Card className="outreach-card shadow-sm border-0">
                                <div className="outreach-header bg-dark py-3 px-4 d-flex justify-content-between align-items-center rounded-top flex-wrap gap-3">
                                    <h5 className="mb-0 text-white"><FaHistory className="me-2" /> Campaign Activity Logs</h5>
                                    <div className="d-flex align-items-center gap-3">
                                        <Badge bg="light" text="dark">{history.length} on this page</Badge>
                                        <Button variant="outline-danger" size="sm" className="fw-bold bg-white text-danger border-white" onClick={clearAllHistory} disabled={history.length === 0}>
                                            <FaTrash className="me-1" size={12} /> Clear All
                                        </Button>
                                    </div>
                                </div>
                                <Card.Body className="p-0">
                                    <div className="table-responsive">
                                        <Table hover bordered className="mb-0 campaign-log-table">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="px-4">Date</th>
                                                    <th>Subject</th>
                                                    <th>Type</th>
                                                    <th className="text-center">Total</th>
                                                    <th className="text-center">📧 Sent</th>
                                                    <th className="text-center">📧 Fail</th>
                                                    <th className="text-center">💬 Sent</th>
                                                    <th className="text-center">💬 Fail</th>
                                                    <th className="text-center">💬 Skip</th>
                                                    <th className="text-center">Status</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {history.map((h) => (
                                                    <React.Fragment key={h.id}>
                                                        <tr>
                                                            <td className="px-4">
                                                                <div className="small fw-bold">{new Date(h.created_at).toLocaleDateString()}</div>
                                                                <div className="text-muted small">{new Date(h.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                                                            </td>
                                                            <td className="fw-semibold">{h.subject || 'No Subject'}</td>
                                                            <td><Badge bg="info" text="dark" className="text-capitalize">{h.campaign_type || '-'}</Badge></td>
                                                            <td className="text-center fw-semibold">{Number(h.total_recipients ?? 0)}</td>
                                                            <td className="text-center text-success fw-semibold">{Number(h.sent_count ?? 0)}</td>
                                                            <td className="text-center text-danger fw-semibold">{Number(h.failed_count ?? 0)}</td>
                                                            <td className="text-center fw-semibold" style={{ color: '#25D366' }}>{Number(h.whatsapp_sent ?? 0)}</td>
                                                            <td className="text-center text-danger fw-semibold">{Number(h.whatsapp_failed ?? 0)}</td>
                                                            <td className="text-center text-warning fw-semibold">{Number(h.whatsapp_skipped ?? 0)}</td>
                                                            <td className="text-center">
                                                                <span className={`status-badge status-${h.status || 'in_progress'}`}>
                                                                    {h.status === 'completed' ? <FaCheckCircle className="me-1" /> : h.status === 'failed' ? <FaExclamationTriangle className="me-1" /> : <Spinner animation="border" size="sm" className="me-1" />}
                                                                    {h.status || 'in_progress'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="d-flex gap-2 justify-content-center">
                                                                    <Button variant="outline-primary" size="sm" onClick={() => toggleRow(h.id)} style={{ width: '60px' }}>
                                                                        {expandedRow === h.id ? 'Hide' : 'View'}
                                                                    </Button>
                                                                    <Button variant="outline-danger" size="sm" onClick={() => deleteHistoryLog(h.id)} title="Delete Log">
                                                                        <FaTrash size={12} />
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {expandedRow === h.id && (
                                                            <tr>
                                                                <td colSpan="11" className="p-0">
                                                                    <div className="campaign-details p-4 bg-light border-top">
                                                                        <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
                                                                            <h6 className="mb-0">Recipient Delivery Status</h6>
                                                                            <OverlayTrigger trigger={['click']} placement="left" rootClose
                                                                                overlay={
                                                                                    <Popover id={`campaign-message-${h.id}`} className="campaign-message-popover">
                                                                                        <Popover.Header as="h3">Campaign Message</Popover.Header>
                                                                                        <Popover.Body><div className="small text-muted campaign-message-body" dangerouslySetInnerHTML={{ __html: h.message || '-' }} /></Popover.Body>
                                                                                    </Popover>
                                                                                }>
                                                                                <Button variant="outline-primary" size="sm" className="campaign-message-trigger" title="View Campaign Message"><FaRegCommentDots /></Button>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                        <div className="table-responsive rounded border bg-white">
                                                                            <Table hover bordered size="sm" className="mb-0 small">
                                                                                <thead className="table-light">
                                                                                    <tr><th className="ps-3">#</th><th>Name</th><th>Email</th><th>Mobile</th><th>User Type</th><th>Sent At</th><th className="text-center">Delivery Status</th></tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {loadingRecipients ? (
                                                                                        <tr><td colSpan="7" className="text-center py-3"><Spinner size="sm" /></td></tr>
                                                                                    ) : campaignRecipients[h.id]?.length > 0 ? (
                                                                                        campaignRecipients[h.id].map((rec, ri) => (
                                                                                            <tr key={ri}>
                                                                                                <td className="ps-3">{ri + 1}</td>
                                                                                                <td>{rec.name || 'User'}</td>
                                                                                                <td style={{ minWidth: '200px' }}>
                                                                                                    {(() => {
                                                                                                        const details = typeof rec.delivery_details === 'string' ? JSON.parse(rec.delivery_details) : (rec.delivery_details || {});
                                                                                                        const emails = (rec.email || '').split(' | ').filter(Boolean);
                                                                                                        return emails.map((email, ei) => {
                                                                                                            const emailDetail = (details.emails || []).find(d => d.address === email);
                                                                                                            return (
                                                                                                                <div key={ei} className="d-flex align-items-center gap-1 mb-1">
                                                                                                                    {emailDetail && (
                                                                                                                        emailDetail.status === 'sent' ? 
                                                                                                                        <span className="text-success" title="Sent Successfully"><FaCheck size={10} /></span> : 
                                                                                                                        <span className="text-danger" title={emailDetail.error || 'Failed'}><FaTimes size={10} /></span>
                                                                                                                    )}
                                                                                                                    <span className="text-truncate interactive-cell" style={{ fontSize: '11px' }} onClick={() => handleEmailAction(email)}>{email}</span>
                                                                                                                </div>
                                                                                                            );
                                                                                                        });
                                                                                                    })()}
                                                                                                </td>
                                                                                                <td style={{ minWidth: '180px' }}>
                                                                                                    {(() => {
                                                                                                        const details = typeof rec.delivery_details === 'string' ? JSON.parse(rec.delivery_details) : (rec.delivery_details || {});
                                                                                                        const phones = (rec.mobile || '').split(' | ').filter(Boolean);
                                                                                                        return phones.map((phone, pi) => {
                                                                                                            const cleanPhone = phone.replace(/\s+/g, '');
                                                                                                            const phoneDetail = (details.mobiles || []).find(d => d.phone === cleanPhone);
                                                                                                            return (
                                                                                                                <OverlayTrigger
                                                                                    key={pi}
                                                                                    trigger="click"
                                                                                    rootClose
                                                                                    placement="auto"
                                                                                    container={document.body}
                                                                                    overlay={renderContactPopover(phone, h.message)}
                                                                                >
                                                                                    <div className="d-flex align-items-center gap-1 mb-1 interactive-cell contact-cell px-1 rounded" style={{ fontSize: '11px', whiteSpace: 'nowrap', cursor: 'pointer', minHeight: '18px' }}>
                                                                                                                    {phoneDetail && (
                                                                                                                        phoneDetail.status === 'sent' ? 
                                                                                                                        <span className="text-success" title="Sent Successfully"><FaCheck size={11} /></span> : 
                                                                                                                        phoneDetail.status === 'skipped' ?
                                                                                                                        <span className="text-warning" title="Skipped (Blocked/Limit)"><FaExclamationCircle size={11} /></span> :
                                                                                                                        <span className="text-danger" title={phoneDetail.reason || 'Failed'}><FaTimes size={11} /></span>
                                                                                                                    )}
                                                                                                                    {phone}
                                                                                                                </div>
                                                                                                            </OverlayTrigger>
                                                                                                            );
                                                                                                        });
                                                                                                    })()}
                                                                                                </td>
                                                                                                <td className="text-capitalize">{rec.user_type || '-'}</td>
                                                                                                <td>{rec.sent_at ? new Date(rec.sent_at).toLocaleString() : '-'}</td>
                                                                                                <td className="text-center">
                                                                                                    <div className="d-flex flex-column gap-1 align-items-center">
                                                                                                        {rec.status && rec.status !== 'skipped' && rec.status !== 'pending' && (
                                                                                                            <Badge bg={rec.status === 'failed' ? 'danger' : 'success'} className="d-flex align-items-center gap-1" style={{ width: 'fit-content' }}>
                                                                                                                <FaEnvelope size={10} /> {rec.status === 'failed' ? 'Failed' : 'Sent'}
                                                                                                            </Badge>
                                                                                                        )}
                                                                                                        {rec.channel && rec.channel.includes('whatsapp') && rec.whatsapp_status && rec.whatsapp_status !== 'pending' && (
                                                                                                            <Badge bg={rec.whatsapp_status === 'failed' ? 'danger' : rec.whatsapp_status === 'skipped' ? 'warning' : 'success'} className="d-flex align-items-center gap-1 text-white" style={{ width: 'fit-content', backgroundColor: rec.whatsapp_status === 'sent' ? '#25D366' : undefined }}>
                                                                                                                <FaWhatsapp size={11} /> {rec.whatsapp_status === 'failed' ? 'Failed' : rec.whatsapp_status === 'skipped' ? 'Skipped' : 'Sent'}
                                                                                                            </Badge>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    ) : (
                                                                                        <tr><td colSpan="7" className="text-center text-muted py-3">No recipient records.</td></tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </Table>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                                {history.length === 0 && <tr><td colSpan="11" className="text-center py-5 text-muted">No campaign activity found.</td></tr>}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <PaginationControls currentPage={historyPage} totalPages={historyTotalPages} onPageChange={(p) => fetchHistory(p)} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* ── Advanced Download Modal ── */}
            <Modal
                show={showAdvancedDownloadModal}
                onHide={() => !downloadInProgress && setShowAdvancedDownloadModal(false)}
                centered
                size="lg"
                backdrop={downloadInProgress ? 'static' : true}
            >
                <Modal.Header closeButton={!downloadInProgress} className="bg-primary text-white border-0">
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <FaDownload size={18} />
                        <div>
                            <div className="fw-bold">Advanced Download</div>
                            <div className="small fw-normal opacity-75" style={{ fontSize: '12px' }}>
                                Choose exact columns and mobile number formats
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4 px-4">
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label className="small fw-bold text-uppercase text-muted mb-0" style={{ letterSpacing: '0.5px' }}>
                                Fields to Download
                            </Form.Label>
                            <div className="d-flex gap-2 align-items-center">
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 fw-bold text-primary text-decoration-none"
                                    style={{ fontSize: '12px' }}
                                    onClick={() => setSelectedExportFields(EXPORT_FIELD_OPTIONS.map(f => f.key))}
                                >
                                    Select All
                                </Button>
                                <span className="text-muted">|</span>
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 fw-bold text-secondary text-decoration-none"
                                    style={{ fontSize: '12px' }}
                                    onClick={() => setSelectedExportFields([])}
                                >
                                    Clear
                                </Button>
                            </div>
                        </div>
                        <Row className="g-2">
                            {EXPORT_FIELD_OPTIONS.map(field => {
                                const checked = selectedExportFields.includes(field.key);
                                return (
                                    <Col key={field.key} xs={12} sm={6} md={4}>
                                        <label
                                            className="d-flex align-items-center w-100"
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                padding: '8px 12px',
                                                borderRadius: '8px',
                                                border: `1px solid ${checked ? '#0d6efd' : '#dee2e6'}`,
                                                backgroundColor: checked ? 'rgba(13, 110, 253, 0.08)' : '#ffffff',
                                                color: checked ? '#0d6efd' : '#495057',
                                                gap: '10px',
                                                transition: 'all 0.15s ease',
                                                margin: 0
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={() => toggleExportField(field.key)}
                                                style={{
                                                    width: '16px',
                                                    height: '16px',
                                                    margin: 0,
                                                    cursor: 'pointer',
                                                    accentColor: '#0d6efd',
                                                    flexShrink: 0
                                                }}
                                            />
                                            <span style={{ lineHeight: '1.2' }}>{field.label}</span>
                                        </label>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>

                    {selectedExportFields.includes('mobiles') && (
                        <div className="mb-4 p-3 rounded border bg-light">
                            <div className="mb-3 pb-3 border-bottom">
                                <Form.Label className="small fw-bold text-uppercase text-muted mb-1 d-block" style={{ letterSpacing: '0.5px' }}>
                                    Phone Layout
                                </Form.Label>
                                <div className="small text-muted mb-2" style={{ fontSize: '12px' }}>
                                    Choose how multiple phone numbers per lead are arranged in the file.
                                </div>
                                <div className="d-flex gap-2 flex-wrap">
                                    {[
                                        { key: 'stacked', title: 'All numbers in one column', subtitle: 'Each phone gets its own row; other fields repeat per row.' },
                                        { key: 'wide',    title: 'Separate column per number', subtitle: 'Mobile 1, Mobile 2, Mobile 3 each become their own column.' }
                                    ].map(opt => {
                                        const active = phoneLayout === opt.key;
                                        return (
                                            <button
                                                key={opt.key}
                                                type="button"
                                                onClick={() => setPhoneLayout(opt.key)}
                                                className="flex-fill text-start"
                                                style={{
                                                    minWidth: '220px',
                                                    padding: '10px 12px',
                                                    borderRadius: '8px',
                                                    border: `1px solid ${active ? '#fd7e14' : '#dee2e6'}`,
                                                    background: active ? 'rgba(253, 126, 20, 0.08)' : '#ffffff',
                                                    color: active ? '#fd7e14' : '#495057',
                                                    transition: 'all 0.15s ease',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <div className="fw-bold" style={{ fontSize: '13px' }}>
                                                    {active ? '● ' : '○ '}{opt.title}
                                                </div>
                                                <div className="small text-muted mt-1" style={{ fontSize: '11px' }}>
                                                    {opt.subtitle}
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="mb-3 pb-3 border-bottom">
                                <Form.Check
                                    type="switch"
                                    id="bulk-skip-empty-phones-switch"
                                    checked={skipEmptyPhones}
                                    onChange={(e) => setSkipEmptyPhones(e.target.checked)}
                                    label={
                                        <span style={{ fontSize: '13px', fontWeight: 600 }}>
                                            Skip rows where every selected phone is empty
                                            <span className="text-muted ms-2" style={{ fontSize: '11px', fontWeight: 400 }}>
                                                (avoids blank rows in the file)
                                            </span>
                                        </span>
                                    }
                                />
                            </div>

                            <div className="mb-3 pb-3 border-bottom">
                                <Form.Label className="small fw-bold text-uppercase text-muted mb-1 d-block" style={{ letterSpacing: '0.5px' }}>
                                    Default Country Code
                                </Form.Label>
                                <div className="small text-muted mb-2" style={{ fontSize: '12px' }}>
                                    Fallback only — the lead's actual stored country code is used when available.
                                    This default is applied only when a number has no code on file.
                                </div>
                                <Form.Select
                                    size="sm"
                                    value={defaultCountryCode}
                                    onChange={(e) => setDefaultCountryCode(e.target.value)}
                                    style={{ maxWidth: '320px' }}
                                >
                                    <option value="">None — leave numbers as-is</option>
                                    {countryData.map((c) => (
                                        <option key={`${c.name}-${c.dial_code}`} value={c.dial_code}>
                                            {c.dial_code} — {c.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                                <Form.Label className="small fw-bold text-uppercase text-muted mb-0" style={{ letterSpacing: '0.5px' }}>
                                    Mobile Formats
                                </Form.Label>
                                <div className="d-flex gap-2 align-items-center">
                                    <span className="text-muted small" style={{ fontSize: '11px' }}>
                                        Each format creates its own column.
                                    </span>
                                    <span className="text-muted">|</span>
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="p-0 fw-bold text-success text-decoration-none"
                                        style={{ fontSize: '12px' }}
                                        onClick={() => setSelectedPhoneFormats(PHONE_FORMAT_OPTIONS.map(f => f.key))}
                                    >
                                        All
                                    </Button>
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="p-0 fw-bold text-secondary text-decoration-none"
                                        style={{ fontSize: '12px' }}
                                        onClick={() => setSelectedPhoneFormats([])}
                                    >
                                        Clear
                                    </Button>
                                </div>
                            </div>
                            <Row className="g-2">
                                {PHONE_FORMAT_OPTIONS.map(format => {
                                    const checked = selectedPhoneFormats.includes(format.key);
                                    return (
                                        <Col key={format.key} xs={12} sm={6}>
                                            <label
                                                className="d-flex flex-column w-100"
                                                style={{
                                                    cursor: 'pointer',
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    padding: '10px 12px',
                                                    borderRadius: '8px',
                                                    border: `1px solid ${checked ? '#198754' : '#dee2e6'}`,
                                                    backgroundColor: checked ? 'rgba(25, 135, 84, 0.08)' : '#ffffff',
                                                    color: checked ? '#198754' : '#495057',
                                                    transition: 'all 0.15s ease',
                                                    margin: 0
                                                }}
                                            >
                                                <div className="d-flex align-items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={() => togglePhoneFormat(format.key)}
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            margin: 0,
                                                            cursor: 'pointer',
                                                            accentColor: '#198754',
                                                            flexShrink: 0
                                                        }}
                                                    />
                                                    <span style={{ lineHeight: '1.2' }}>{format.label}</span>
                                                </div>
                                                {format.hint && (
                                                    <small className="text-muted mt-1 ms-4" style={{ fontSize: '11px', fontWeight: 400 }}>
                                                        {format.hint}
                                                    </small>
                                                )}
                                            </label>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    )}

                    <div>
                        <Form.Label className="small fw-bold text-uppercase text-muted mb-2 d-block" style={{ letterSpacing: '0.5px' }}>
                            File Type
                        </Form.Label>
                        <div className="d-inline-flex rounded border bg-light p-1">
                            {['xlsx', 'csv'].map(type => (
                                <Button
                                    key={type}
                                    variant={downloadFileType === type ? 'light' : 'link'}
                                    size="sm"
                                    onClick={() => setDownloadFileType(type)}
                                    className={`fw-bold text-uppercase px-3 ${downloadFileType === type ? 'shadow-sm text-primary' : 'text-secondary text-decoration-none'}`}
                                    style={{ fontSize: '12px' }}
                                >
                                    {type === 'xlsx' ? <FaFileExcel className="me-1" /> : <FaFileCsv className="me-1" />}
                                    {type}
                                </Button>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="small text-muted">
                        {leadsTotal} recipient(s) match current filters · {selectedExportFields.length} selected field(s)
                    </div>
                    <div className="d-flex gap-2">
                        <Button
                            variant="outline-secondary"
                            onClick={() => setShowAdvancedDownloadModal(false)}
                            disabled={downloadInProgress}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            className="fw-bold d-flex align-items-center gap-2"
                            onClick={handleAdvancedDownload}
                            disabled={
                                downloadInProgress ||
                                selectedExportFields.length === 0 ||
                                (selectedExportFields.includes('mobiles') && selectedPhoneFormats.length === 0)
                            }
                        >
                            {downloadInProgress
                                ? (<><Spinner animation="border" size="sm" /> Preparing...</>)
                                : (<><FaDownload size={13} /> Download</>)
                            }
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* ── Import Defaults Modal ── */}
            <Modal show={showPasteDataModal} onHide={() => setShowPasteDataModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">
                        <FaRegCommentDots className="me-2 text-primary" />
                        Paste Lead Data
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="small fw-bold">Paste one formatted lead block</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={12}
                            value={pasteLeadText}
                            onChange={(e) => setPasteLeadText(e.target.value)}
                            placeholder={`* Name : Maria Santos\n\n* Job Applied : Lady driver\n\n• Job Country : Qatar\n\n* Gender: Female\n\n* Age: 39\n\n* Nationality: Filipino\n\n* Religion : Catholic\n\n* Mobile Number: 09985592810\n\n* WhatsApp Number: 09985592810\n\n* Email Id: quiellacano@gmail.com`}
                            className="bg-light"
                        />
                        <Form.Text className="text-muted">
                            Matching fields will be filled for review. Agency Name stays empty unless the admin enters it.
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => setShowPasteDataModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleParsePasteLead} disabled={!pasteLeadText.trim()}>
                        Parse & Fill Form
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal 
                show={showImportDefaultsModal} 
                onHide={() => setShowImportDefaultsModal(false)} 
                centered 
                backdrop="static"
                className="import-defaults-modal"
            >
                <Modal.Header className="bg-primary text-white border-0">
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <FaFileUpload size={20} />
                        <span className="fw-bold">Bulk Import Settings</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4 px-4">
                    <p className="text-muted small mb-4">
                        We detected missing information in your file. Please select default values to be applied to records that are missing these details.
                    </p>

                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label className="small fw-bold text-uppercase text-muted" style={{ letterSpacing: '0.5px' }}>
                                <FaGlobe className="me-2 text-primary" /> Default Country Code
                            </Form.Label>
                            <Form.Select
                                value={importDefaults.countryCode}
                                onChange={(e) => setImportDefaults({ ...importDefaults, countryCode: e.target.value })}
                                className="bg-light border-0"
                                style={{ height: '45px' }}
                            >
                                {countryData.map((c, idx) => (
                                    <option key={idx} value={c.dial_code}>{c.name} ({c.dial_code})</option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted small">Applied to mobile numbers without a '+' prefix.</Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="small fw-bold text-uppercase text-muted" style={{ letterSpacing: '0.5px' }}>
                                <FaTag className="me-2 text-primary" /> Default Job Category
                            </Form.Label>
                            <Form.Select
                                value={importDefaults.category}
                                onChange={(e) => {
                                    setImportDefaults({ 
                                        ...importDefaults, 
                                        category: e.target.value,
                                        jobPosition: '' 
                                    });
                                }}
                                className="bg-light border-0"
                                style={{ height: '45px' }}
                            >
                                <option value="">Select Category</option>
                                {CATEGORY_OPTIONS.map((cat, idx) => (
                                    <option key={idx} value={cat}>{cat}</option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted small">Applied to records with empty or 'General' category.</Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="small fw-bold text-uppercase text-muted" style={{ letterSpacing: '0.5px' }}>
                                <FaUser className="me-2 text-primary" /> Default Job Position
                            </Form.Label>
                            <Form.Select
                                value={importDefaults.jobPosition}
                                onChange={(e) => setImportDefaults({ ...importDefaults, jobPosition: e.target.value })}
                                className="bg-light border-0"
                                style={{ height: '45px' }}
                                disabled={!importDefaults.category}
                            >
                                <option value="">Select Position</option>
                                {(JOB_POSITIONS_BY_CATEGORY[importDefaults.category] || []).map((pos, idx) => (
                                    <option key={idx} value={pos}>{pos}</option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted small">Applied to records with no job position.</Form.Text>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4">
                    <Button variant="outline-secondary" onClick={() => { setShowImportDefaultsModal(false); setPendingUploadLeads([]); }}>
                        Cancel Import
                    </Button>
                    <Button 
                        variant="primary" 
                        className="px-4 fw-bold shadow-sm"
                        onClick={processPendingUpload}
                        disabled={!importDefaults.countryCode && !importDefaults.category}
                    >
                        Apply & Save Leads
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* ── WhatsApp QR Code Modal ── */}
            <Modal show={showQRModal} onHide={() => setShowQRModal(false)} centered className="wa-qr-modal">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <FaWhatsapp size={24} className="text-success" />
                        <span className="fw-bold">Scan QR Code</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    {waQR ? (
                        <div>
                            <p className="text-muted small mb-3">Open WhatsApp on your phone → Linked Devices → Link a Device → Scan this QR</p>
                            <div className="d-inline-block p-3 bg-white rounded-3 shadow-sm border">
                                <img src={waQR} alt="WhatsApp QR Code" style={{ width: '280px', height: '280px' }} />
                            </div>
                            <div className="mt-3">
                                <Button variant="outline-secondary" size="sm" onClick={fetchWaSession} className="fw-bold">
                                    <FaSync size={11} className={`me-1 ${loadingWaSession ? 'fa-spin' : ''}`} /> Refresh QR
                                </Button>
                            </div>
                        </div>
                    ) : waSession.status === 'connecting' ? (
                        <div className="py-5">
                            <Spinner animation="border" variant="success" />
                            <p className="mt-3 text-muted small">Connecting to WhatsApp...</p>
                        </div>
                    ) : waSession.status === 'connected' ? (
                        <div className="py-5">
                            <FaCheckCircle size={48} className="text-success mb-3" />
                            <p className="fw-bold text-success">WhatsApp Connected!</p>
                            <Button variant="outline-secondary" size="sm" onClick={() => setShowQRModal(false)}>Close</Button>
                        </div>
                    ) : (
                        <div className="py-5">
                            <p className="text-muted">Waiting for QR code...</p>
                            <Button variant="success" size="sm" onClick={startWaSession}>Start Session</Button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AdminBulkOutreach;
